// src/data/versesData.js

// export const versesData = [
//   {
//     id: 1,
//     sanskrit: `भक्तामर-प्रणत-मौलि-मणि-प्रभाणा-
//         मुद्योतकं दलित-पाप-तमो-वितानम्।
//         सम्यक्-प्रणम्य जिन-पाद-युगं युगाद्यं
//         वालम्बनं भव-जले पततां जनानाम्॥१॥`,

//     transliteration: `Bhaktāmara-praṇata-mauli-maṇi-prabhāṇā-
//         mudyotakaṃ dalita-pāpa-tamo-vitānam।
//         Samyak-praṇamya jina-pāda-yugaṃ yugādyaṃ
//         Tasmai namo jina-varāya bhavanti nityam॥1॥`,

//     english: "I bow to the supreme Jina, whose radiant feet, worshipped by the jeweled crowns of devotees, disperse the darkness of sins and provide refuge to beings lost in the vast ocean of existence.",

//     hindi: "भक्तों के मुकुट-मणियों से शोभित चरण, जिनकी आभा से पापरूपी अंधकार नष्ट हो जाता है और जो संसार सागर में डूबे प्राणियों को सहारा देते हैं—ऐसे आदि जिनेन्द्र को मैं नित्य नमस्कार करता हूँ।",

//     benefits: "Removes sins and obstacles, grants liberation, peace, and divine support."
//   },
//   {
//     id: 2,
//     sanskrit: `यः संस्तुतः सकल-वाङ्मय-तत्त्व-बोधा-
// दुद्भूत-बुद्धिपटुभिः सुरलोक-नाथैः ।
// स्तोत्रैर्जगत्-त्रितय-चित्त-हरैरुदारैः
// स्तोष्ये किलाहमपि तं प्रथमं जिनेन्द्रम्॥२॥`,

//     transliteration: `Yaḥ saṃstutaḥ sakala-vāṅmaya-tattva-bodhā-
//         dudbhūta-buddhi-paṭubhiḥ suraloka-nāthaiḥ।
//         Stotreṇa menaṃ praṇato'smi taṃ jinendraṃ
//         Prathamaṃ jinaṃ śaraṇamadya mano mamāyāt॥2॥`,

//     english: "The Lord who is praised by all gods and extolled in the essence of the Vedas, whose glory captivates the three worlds—unto that first Jinendra, I bow with devotion.",

//     hindi: "वेदों के सार को जानने वाले देवताओं द्वारा जिनकी स्तुति की जाती है, ऐसे प्रथम जिनेन्द्र जिनकी महिमा तीनों लोकों को मोहित कर लेती है—मैं उन्हें प्रणाम करता हूँ।",

//     benefits: "Brings wisdom, strengthens devotion, and grants divine grace."
//   },
//   {
//     id: 3,
//     sanskrit: `बुद्ध्या विनापि विबुधार्चित-पादपीठं
//         स्तोतुं समुत्सुकमतिर्विगतत्रपः सन्।
//         दूरे सदा स्तुति-शक्तिर्मम जायतेऽद्य
//         यद्यप्यहं जलनिधौ शशिमण्डलं यथा॥३॥`,

//     transliteration: `Buddhyā vināpi vibudhārcita-pādapīṭhaṃ
//         Stotuṃ samutsukamatirvigatatrapaḥ san।
//         Dūre sadā stuti-śaktirmama jāyate'dya
//         Yadyapyahaṃ jalanidhau śaśimaṇḍalaṃ yathā॥3॥`,

//     english: "Even without intellect, I long to praise those lotus feet worshipped by the gods. Though my power of praise is meager, I attempt like a child striving to catch the moon’s reflection in water.",

//     hindi: "देवताओं द्वारा पूजित उन चरणों की स्तुति करने के लिए मेरी बुद्धि अल्प है, फिर भी मैं निःसंकोच प्रयास करता हूँ, जैसे कोई बालक जल में दिखते चंद्रमा को पकड़ना चाहता है।",

//     benefits: "Cultivates humility, removes ego, and builds persistence in spiritual practice."
//   },
//   {
//     id: 4,
// sanskrit: `वक्तुं गुणान्गुणसमुद्र शशाङ्ककान्तान्
//         कस्ते क्षमो भुवनचक्र विभूतिनाथ।
//         को वा भवद्यशसि पतितं समग्रं
//         वक्तुं प्रभो त्वमसि नाथ परं हि सर्वम्॥४॥`,

// transliteration: `Vaktum guṇānguṇasamudra śaśāṅkakāntān
//         Kaste kṣamo bhuvanacakra vibhūtinātha।
//         Ko vā bhavadyaśasi patitaṃ samagraṃ
//         Vaktum prabho tvamasi nātha paraṃ hi sarvam॥4॥`,

// english: "O Lord, who in this world is capable of describing your virtues, shining like the moon and as vast as the ocean? Who can ever recount all your glory? For you are truly the supreme source of everything.",

// hindi: "हे प्रभु! आपके गुण, जो समुद्र के समान असीम और चन्द्रमा के समान शोभायमान हैं, उनका वर्णन करने में कौन समर्थ है? आपके यश की सम्पूर्णता को कौन कह सकता है? आप ही सबका परम कारण हैं।",

// benefits: "Destroys pride, inspires humility, and fills the devotee with reverence for the infinite qualities of the Lord."

//   },
//   {
// id: 5,
// sanskrit: `सोऽहमपि तव भक्तिरेव भूतिं
//         स्तोतुं कृतः प्रणतिनम्रविपन्नवाचः।
//         किं तु स्थिरा मम न चेतसि नाथ! भक्तिः
//         कस्त्वां स्तवेन्मुनिवर! प्रतिभातु मेऽद्या॥३॥`,

// transliteration: `So'hamapi tava bhaktireva bhūtiṃ
//         Stotuṃ kṛtaḥ praṇatinamravipannavācaḥ।
//         Kiṃ tu sthirā mama na cetasi nātha! bhaktiḥ
//         Kastvāṃ stavennuṇivara! pratibhātu me'dyā॥3॥`,

// english: "Even I, though my words falter and fail, attempt to praise you, O Lord, only because of devotion. But alas, my devotion is not steady in my heart. O Sage among Lords, who indeed can truly sing your glory? May inspiration dawn upon me today.",

// hindi: "हे नाथ! मैं भी केवल भक्ति के कारण आपकी स्तुति करने का प्रयास करता हूँ, यद्यपि मेरी वाणी दीन और असमर्थ है। किंतु मेरे हृदय में भक्ति स्थिर नहीं है। हे मुनिवर! आपकी महिमा का वर्णन कौन कर सकता है? आज मुझे प्रेरणा प्राप्त हो।",

// benefits: "Instills humility, awakens true devotion, and invites divine inspiration for spiritual expression."

//   },
//   {
// id: 6,
// sanskrit: `अल्पश्रुतं श्रुतवतां परिहास्य मीढ्यं
//         त्वद्भक्तिरेव मुखरीकुरुते बलान्माम्।
//         यत्कोकिलः किल मधौ मधुरं विरौति
//         तच्चाम्रवृक्षसुभगेषु निसर्गतोऽपि॥२॥`,

// transliteration: `Alpaśrutaṃ śrutavatāṃ parihāsya mīḍhyaṃ
//         Tvadbhaktireva mukharīkurute balānmām।
//         Yatkōkilaḥ kila madhau madhuraṃ virauti
//         Taccāmravṛkṣasubhageṣu nisargato'pi॥2॥`,

// english: "Though my knowledge is meagre and laughable before the learned, it is your devotion alone that compels me to sing your praises. Just as the cuckoo sweetly sings in spring, though only among the blossoming mango trees, so too my words gain beauty only through devotion to you.",

// hindi: "मेरी अल्पश्रुति विद्वानों के सामने उपहास योग्य है। परंतु आपकी भक्ति ही मुझे मुखरित कर देती है। जैसे कोयल वसंत ऋतु में आम्रवृक्षों की शोभा में ही मधुर गाती है, वैसे ही आपकी भक्ति से ही मेरी वाणी मधुर बनती है।",

// benefits: "Encourages even the less-learned to engage in devotion; grants sweetness in speech and removes self-doubt."

//   },
//   {
//    id: 7,
// sanskrit: `त्वत्संस्तवेन भवसन्ततिसन्निबद्धं
//         पापं क्षणात्क्षयमुपैति शरीरभाजाम्।
//         आक्रान्तलोकमलिनीळमशेषमाशु
//         सूर्यांशुभिन्नमिव शार्वरमन्धकारम्॥७॥`,

// transliteration: `Tvat-saṃstavena bhava-santati-sannibaddhaṃ
//         Pāpaṃ kṣaṇāt kṣayamupaiti śarīrabhājām।
//         Ākrāntaloka-malinīla-maśeṣamāśu
//         Sūryāṃśu-bhinnamiva śārvaramandhakāram॥7॥`,

// english: "By your praise, the sins accumulated through countless births are instantly destroyed in embodied beings, just as the rising sun disperses the dense darkness of night that covers the whole world.",

// hindi: "आपकी स्तुति करने से, जन्म-जन्मान्तरों का संचित पाप क्षणभर में नष्ट हो जाता है; जैसे उदय होता हुआ सूर्य सम्पूर्ण लोक में फैले गहन अंधकार को शीघ्र ही दूर कर देता है।",

// benefits: "Destroys accumulated sins, removes ignorance and darkness, and fills the devotee’s life with divine light and purity."

//   },
//   {
//     id: 8,
// sanskrit: `मत्वेति नाथ! तव संस्तवनं मयेद-
//         मारभ्यते तनुधियापि तव प्रभावात्।
//         चेतो हरिष्यति सतां नलिनी-दलेषु
//         मुक्ताफलद्युतिमुपैति ननूदबिन्दुः॥८॥`,

// transliteration: `Matveti nātha! tava saṃstavanaṃ mayeda-
//         Mārabhyate tanudhiyāpi tava prabhāvāt।
//         Ceto hariṣyati satāṃ nalinī-daleṣu
//         Muktā-phaladyutimupaiti nanūdabinduḥ॥8॥`,

// english: "O Lord! Considering this, I begin your praise even with my feeble intellect, for such is the power of your glory. Just as a drop of water, when it falls on a lotus leaf, shines with the brilliance of a pearl, so too my words may shine when devoted to you.",

// hindi: "हे नाथ! यह सोचकर कि आपके प्रभाव से ही सब संभव है, मैं अपनी क्षीण बुद्धि से भी आपकी स्तुति आरंभ करता हूँ। जैसे जल की बूँद कमल-पत्र पर गिरकर मोती के समान दीप्त हो उठती है, वैसे ही आपकी भक्ति से मेरी वाणी भी शोभायमान हो जाएगी।",

// benefits: "Transforms even limited abilities into radiant devotion, grants clarity, and inspires confidence in spiritual expression."

//   },
//   {
// id: 9,
// sanskrit: `आस्तां तव स्तवनमस्तसमस्तदोषं
//         त्वत्संकथाऽपि जगतां दुरितानि हन्ति।
//         दूरे सहस्रकिरणः कुरुते प्रभैव
//         पद्माकरेषु जलजानि विकासभांजि॥९॥`,

// transliteration: `Āstāṃ tava stavana-masta-samasta-doṣaṃ
//         Tvat-saṅkathā'pi jagatāṃ duritāni hanti।
//         Dūre sahasrakiraṇaḥ kurute prabhaiva
//         Padmākareṣu jalajāni vikāsabhāñji॥9॥`,

// english: "Let your hymn be free of every fault, O Lord, for even the mere narration of your glory destroys the sins of the world. Just as the sun’s rays, from afar, cause the lotuses in the lakes to bloom, so too does your praise uplift all beings.",

// hindi: "हे प्रभु! आपकी स्तुति यदि सभी दोषों से रहित न भी हो, तो भी केवल आपके नाम और गुणों की कथा ही जगत के पापों का नाश कर देती है। जैसे दूर से ही सूर्य की किरणें कमलों को खिला देती हैं, वैसे ही आपकी वंदना जीवों को पवित्र कर देती है।",

// benefits: "Destroys sins even by hearing or speaking of the Lord’s virtues; spreads positivity and spiritual awakening like sunlight."

//   },
//  {
// id: 10,
// sanskrit: `नात्यद्भुतं भुवनभूषण! भूतनाथ!
//         भूतैर्गुणैर्भुवि भवन्तमभिष्टुवन्तः।
//         तुल्या भवन्ति भवतो ननु तेन किं वा
//         भूत्याश्रितं य इह नात्मसमं करोति॥१०॥`,

// transliteration: `Nātyadbhutaṃ bhuvanabhūṣaṇa! bhūtanātha!
//         Bhūtairguṇairbhuvi bhavantamabhiṣṭuvantaḥ।
//         Tulyā bhavanti bhavato nanu tena kiṃ vā
//         Bhūtyāśritaṃ ya iha nātmasamaṃ karoti॥10॥`,

// english: "O Ornament of the Worlds, Lord of Beings! It is not surprising that those who praise you with their virtues become elevated and equal in greatness. For is it strange if one who relies on true greatness becomes great himself?",

// hindi: "हे भुवन-भूषण, हे भूतनाथ! यह कोई आश्चर्य नहीं कि जो लोग अपने गुणों द्वारा आपकी स्तुति करते हैं, वे महान बन जाते हैं और आपकी महिमा के समान हो जाते हैं। क्योंकि जो सच्ची महिमा का आश्रय लेता है, वह स्वयं महान हो जाता है।",

// benefits: "Elevates the devotee’s virtues, removes feelings of inferiority, and grants greatness and divine stature."

//  },
// {
//   id: 11,
//   sanskrit: `दृष्ट्वा भवन्त मनिमेष-विलोकनीयं,
// नान्यत्र-तोष-मुपयाति जनस्य चक्षु: ।
// पीत्वा पय: शशिकर-द्युति-दुग्ध-सिन्धो:,
// क्षारं जलं जलनिधेरसितुं क इच्छेत्?॥११॥`,

//   transliteration: `Dṛṣṭvā bhavanta manimeṣa-vilokanīyaṃ
// Nānyatra-toṣamupayāti janasya cakṣuḥ।
// Pītvā payaḥ śaśikara-dyuti-dugdha-sindhoḥ
// Kṣāraṃ jalaṃ jalanidher asituṃ ka icchet॥11॥`,

//   english: "Having seen You, O Lord, whose beauty is beyond compare, the eyes of beings find no delight elsewhere. Just as one who has tasted nectar from the ocean of moonlight would never desire to drink salty water from the sea.",

//   hindi: "हे प्रभु! आपको देखकर, जो अनुपम दर्शनीय हैं, प्राणी की आँखें और कहीं तृप्त नहीं होतीं। जैसे चंद्रकिरणों के अमृतमय सागर का पान करने वाला खारे समुद्र का जल पीना नहीं चाहेगा।",

//   benefits: "Fixes the mind on the divine form, turns eyes away from worldly distractions, and fills the devotee with inner bliss."
// },
// {
//   id: 12,
//   sanskrit: `यै: शान्त-राग-रुचिभि: परमाणुभिस्-त्वं,
// निर्मापितस्-त्रि-भुवनैक-ललाम-भूत !
// तावन्त एव खलु तेऽप्यणव: पृथिव्यां,
// यत्ते समान-मपरं न हि रूप-मस्ति ॥१२॥`,

//   transliteration: `Yaiḥ śānta-rāga-rucibhiḥ paramāṇubhis tvaṃ
// Nirmāpitas tri-bhuvanaika-lalāma-bhūta!
// Tāvanta eva khalu te’pyaṇavaḥ pṛthivyāṃ
// Yatte samānam aparaṃ na hi rūpam asti॥12॥`,

//   english: "O Ornament of the three worlds! You are formed of countless atoms radiant with serene lustre. Though the earth contains innumerable atoms, none equal Your form; truly, there is no other beauty like Yours.",

//   hindi: "हे त्रिभुवन के आभूषण! आप शांत, पवित्र, तेजस्वी परमाणुओं से निर्मित हैं। यद्यपि पृथ्वी पर असंख्य परमाणु हैं, फिर भी आपके स्वरूप के समान कोई अन्य नहीं।",

//   benefits: "Brings realization of the Lord’s uniqueness, develops spiritual discrimination, and deepens reverence."
// },
// {
//   id: 13,
//   sanskrit: `वक्त्रं क्व ते सुर-नरोरग-नेत्र-हारि,
// नि:शेष-निर्जित-जगत्त्रितयोपमानम् ।
// बिम्बं कलंक-मलिनं क्व निशाकरस्य,
// यद्वासरे भवति पाण्डुपलाश-कल्पम् ॥१३॥`,

//   transliteration: `Vaktraṃ kva te sura-naroraga-netra-hāri
// Niḥśeṣa-nirjita-jagattritayopamānam।
// Bimbaṃ kalaṅka-malinaṃ kva niśākarasya
// Yad vāsare bhavati pāṇḍu-palāśa-kalpam॥13॥`,

//   english: "Where is Your radiant face, stealing the gaze of gods, men, and serpents, surpassing all three worlds in beauty? And where is the blemished orb of the moon, pale like a withered lotus by day?",

//   hindi: "देवताओं, मनुष्यों और नागों की दृष्टि को मोहित करने वाला, त्रिलोक की समस्त उपमाओं को जीतने वाला आपका मुख कहाँ और कलंकों से युक्त, दिन में फीके पड़े हुए चंद्रमा का बिंब कहाँ!",

//   benefits: "Removes vanity of worldly beauty, increases focus on divine form, and grants clarity of perception."
// },
// {
//   id: 14,
//   sanskrit: `सम्पूर्ण-मण्डल-शशांक-कला-कलाप-
// शुभ्रा गुणास्-त्रि-भुवनं तव लंघयन्ति ।
// ये संश्रितास्-त्रि-जगदीश्वरनाथ-मेकं,
// कस्तान् निवारयति संचरतो यथेष्टम् ॥१४॥`,

//   transliteration: `Sampūrṇa-maṇḍala-śaśāṅka-kalā-kalāpa-
// Śubhrā guṇās tri-bhuvanaṃ tava laṅghayanti।
// Ye saṃśritās tri-jagadīśvara-nātham ekaṃ
// Kas tān nivārayati saṃcarato yatheṣṭam॥14॥`,

//   english: "Your pure and radiant virtues, like the full moon’s beams, pervade and surpass the three worlds. Those who take refuge in You, O Lord of the universe, move freely as they wish—who can hinder them?",

//   hindi: "आपके श्वेत और उज्ज्वल गुण पूर्णचंद्र की कलाओं के समान त्रिभुवन को लांघ जाते हैं। जो भक्त आपके शरणागत होते हैं, हे जगन्नाथ! वे स्वतंत्रतापूर्वक विचरण करते हैं, उन्हें रोकने वाला कौन है?",

//   benefits: "Destroys obstacles, grants freedom of movement in life and spirit, and protects devotees everywhere."
// },
// {
//   id: 15,
//   sanskrit: `चित्रं किमत्र यदि ते त्रिदशांग-नाभिर्नीतं
// मनागपि मनो न विकार-मार्गम् ।
// कल्पान्त-काल-मरुता चलिताचलेन,
// किं मन्दराद्रिशिखरं चलितं कदाचित् ॥१५॥`,

//   transliteration: `Citraṃ kimatra yadi te tridaśāṅga-nābhir
// Nītaṃ manāg api mano na vikāra-mārgam।
// Kalpānta-kāla-marutā calitācalena,
// Kiṃ mandarādri-śikharaṃ calitaṃ kadācit॥15॥`,

//   english: "It is indeed a wonder, O Lord, that even with the charms of celestial nymphs, my mind does not stray towards passions. Can the lofty summit of Mount Mandara be shaken by the stormy winds of the cosmic dissolution?",

//   hindi: "हे प्रभु! यह वास्तव में आश्चर्य है कि स्वर्गांगनाओं की मोहिनी छवि भी आपके भक्त के मन को विचलित नहीं कर पाती। जैसे प्रलयकालीन तूफानी पवन भी मन्दराचल की चोटी को हिला नहीं सकती।",

//   benefits: "Bestows stability of mind, protects from worldly temptations, and strengthens celibacy and self-control."
// },
// {
//   id: 16,
//   sanskrit: `निर्धूम-वर्ति-रपवर्जित-तैल-पूर:,
// कृत्स्नं जगत्त्रयमिदं प्रकटीकरोषि ।
// गम्यो न जातु मरुतां चलिताचलानां,
// दीपोऽपरस्त्वमसि नाथ ! जगत्प्रकाश: ॥१६॥`,

//   transliteration: `Nirdhūma-vartir apavarjita-taila-pūraḥ
// Kṛtsnaṃ jagattrayam idaṃ prakaṭīkarosi।
// Gamyo na jātu marutāṃ calitācalānāṃ
// Dīpo’parastvam asi nātha! jagat-prakāśaḥ॥16॥`,

//   english: "Like a smokeless lamp, ever full of oil, You illuminate the three worlds. You are unmoved by storms, unshaken like a mountain. Truly, O Lord, You are the light of the universe!",

//   hindi: "हे प्रभु! आप धूमरहित, सदैव पूर्ण तेलयुक्त दीपक के समान हैं जो सम्पूर्ण त्रिलोक को प्रकाशित करता है। आप वायु और तूफानों से प्रभावित नहीं होते। निश्चय ही आप जगत के प्रकाशस्वरूप दीपक हैं।",

//   benefits: "Removes inner ignorance, grants steadfastness, and fills life with divine illumination."
// },
// {
//   id: 17,
//   sanskrit: `नास्तं कदाचिदुपयासि न राहुगम्य:,
// स्पष्टीकरोषि सहसा युगपज्जगन्ति ।
// नाम्भोधरोदरनिरुद्धमहाप्रभाव:,
// सूर्यातिशायिमहिमासि मुनीन्द्र! लोके ॥१७॥`,

//   transliteration: `Nāstaṃ kadācid upayāsi na rāhugamyaḥ
// Spaṣṭīkarosi sahasā yugapaj jaganti।
// Nāmbhodharodara-niruddha-mahā-prabhāvaḥ
// Sūryātiśāyi-mahimāsi munīndra! loke॥17॥`,

//   english: "You never set, nor are You ever eclipsed. Instantly, You make all worlds shine. Unlike the sun, whose brilliance can be obstructed by clouds, O Sage among sages! Your glory surpasses the sun itself.",

//   hindi: "आप कभी अस्त नहीं होते, न ही राहु द्वारा ग्रस्त किए जा सकते हैं। आप एक साथ सभी लोकों को प्रकाशित कर देते हैं। हे मुनिन्द्र! सूर्य की महिमा मेघों से ढक सकती है, किन्तु आपकी महिमा सूर्य से भी अधिक है।",

//   benefits: "Destroys darkness of ignorance permanently, makes one’s life radiant, and brings eternal clarity."
// },
// {
//   id: 18,
//   sanskrit: `नित्योदयं दलित-मोह-महान्धकारं,
// गम्यं न राहुवदनस्य न वारिदानाम् ।
// विभ्राजते तव मुखाब्जमनल्पकान्ति,
// विद्योतयज्जगदपूर्वशशांकबिम्बम् ॥१८॥`,

//   transliteration: `Nityodayaṃ dalita-moha-mahāndhakāraṃ
// Gamyaṃ na rāhu-vadanasya na vāridānām।
// Vibhrājate tava mukhābjamanalpakānti
// Vidyotayaj jagadapūrva-śaśāṅka-bimbam॥18॥`,

//   english: "Your lotus face rises eternally, dispelling the great darkness of delusion. It cannot be eclipsed by Rahu or clouds. Its unique brilliance outshines even the full moon.",

//   hindi: "आपका कमलमुख नित्य उदित होता है, जो मोह रूपी महान् अंधकार को नष्ट करता है। इसे न राहु निगल सकता है, न ही बादल ढक सकते हैं। इसकी अद्भुत आभा सम्पूर्ण चंद्रमा से भी श्रेष्ठ है।",

//   benefits: "Frees the devotee from delusion, brings constant enlightenment, and radiates peace."
// },
// {
//   id: 19,
//   sanskrit: `किं शर्वरीषु शशिनाह्नि विवस्वता वा,
// युष्मन्मुखेन्दुदलितेषु तम:सु नाथ!
// निष्पन्न-शालिवन-शालिनी जीवलोके,
// कार्यं कियज्जलधरैर्जलभारनमै: ॥१९॥`,

//   transliteration: `Kiṃ śarvarīṣu śaśināhni vivasvatā vā
// Yuṣman-mukhendu-daliteṣu tamaḥsu nātha!
// Niṣpanna-śāli-vana-śālinī jīvaloke
// Kāryaṃ kiyaj jaladharaiḥ jala-bhāra-namaiḥ॥19॥`,

//   english: "When Your moon-like face has dispelled the darkness, O Lord, what need is there for the sun or the moon to shine? When the rice fields are ripe with crops, what use are the heavy-laden clouds?",

//   hindi: "हे प्रभु! जब आपके मुखचंद्रमा ने अंधकार को नष्ट कर दिया, तब सूर्य और चंद्रमा की क्या आवश्यकता रह जाती है? जैसे जब धान के खेत सुनहरे हो गए हों, तब भारी जलयुक्त मेघों की आवश्यकता नहीं रहती।",

//   benefits: "Grants self-sufficiency in inner light, removes dependency on worldly supports, and ensures fulfillment."
// },
// {
//   id: 20,
//   sanskrit: `ज्ञानं यथा त्वयि विभाति कृतावकाशं,
// नैवं तथा हरिहरादिषु नायकेषु ।
// तेजो महा मणिषु याति यथा महत्त्वं,
// नैवं तु काचशकले किरणाकुलेऽपि ॥२०॥`,

//   transliteration: `Jñānaṃ yathā tvayi vibhāti kṛtāvakāśaṃ
// Naivaṃ tathā hari-harādiṣu nāyakeṣu।
// Tejo mahāmaṇiṣu yāti yathā mahattvaṃ
// Naivaṃ tu kāca-śakale kiraṇākule’pi॥20॥`,

//   english: "Knowledge shines fully in You alone, O Lord, not in Hari, Hara, or other deities. Just as brilliance belongs to a true gem, not to pieces of glass, though they may glitter in the sun.",

//   hindi: "हे प्रभु! ज्ञान केवल आप में ही पूर्ण रूप से प्रकट होता है, न कि हरि, हर और अन्य देवताओं में। जैसे वास्तविक रत्न में ही वास्तविक तेज होता है, न कि काँच के टुकड़ों में चाहे वे सूर्यकिरणों से चमकते हों।",

//   benefits: "Develops discrimination, strengthens faith in the true path, and removes confusion between truth and illusion."
// },
// {
//   id: 21,
//   sanskrit: `मन्ये वरं हरिहरादय एव दृष्टा,
// दृष्टेषु येषु हृदयं त्वयि तोषमेति ।
// किं वीक्षितेन भवता भुवि येन नान्य:,
// कश्चिन्मनो हरति नाथ! भवान्तरेऽपि ॥२१॥`,

//   transliteration: `Manye varaṃ hari-harādaya eva dṛṣṭā
// Dṛṣṭeṣu yeṣu hṛdayaṃ tvayi toṣam eti।
// Kiṃ vīkṣitena bhavatā bhuvi yena nānyaḥ
// Kaścin mano harati nātha! bhavāntare’pi॥21॥`,

//   english: "It is perhaps better to have seen Hari and Hara, for only after beholding them does the heart find satisfaction in You. For, once Your vision is attained, O Lord, nothing else can ever capture the mind, even in another birth.",

//   hindi: "शायद हरि और हर को देखना ही अच्छा है, क्योंकि उनके दर्शन के बाद ही हृदय को आपके दर्शन में पूर्ण संतोष मिलता है। हे प्रभु! आपके दर्शन के बाद तो और कोई भी वस्तु जन्म-जन्मान्तर में मन को आकृष्ट नहीं कर सकती।",

//   benefits: "Fixes the devotee’s heart only on the Lord, grants detachment from all else, and gives unshakable devotion."
// },
// {
//   id: 22,
//   sanskrit: `स्त्रीणां शतानि शतशो जनयन्ति पुत्रान्,
// नान्या सुतं त्वदुपमं जननी प्रसूता ।
// सर्वा दिशो दधति भानि सहस्ररश्मिं,
// प्राच्येव दिग्जनयति स्फुरदंशुजालम् ॥२२॥`,

//   transliteration: `Strīṇāṃ śatāni śataśo janayanti putrān
// Nānyā sutaṃ tvadupamaṃ jananī prasūtā।
// Sarvā diśo dadhati bhāni sahasra-raśmiṃ
// Prācyeva dig janayati sphurad-aṃśu-jālam॥22॥`,

//   english: "Thousands of women may give birth to sons, but none has ever borne a son like You. All directions have stars shining, but only the east brings forth the radiant sun.",

//   hindi: "सैकड़ों स्त्रियाँ सैकड़ों पुत्र उत्पन्न करती हैं, किन्तु आपके समान कोई पुत्र किसी ने जन्मा नहीं। सभी दिशाएँ तारों से युक्त होती हैं, परन्तु केवल पूर्व दिशा ही तेजस्वी सूर्य को जन्म देती है।",

//   benefits: "Instills reverence for the Lord’s rarity, awakens humility in the devotee, and inspires gratitude for divine incarnation."
// },
// {
//   id: 23,
//   sanskrit: `त्वामामनन्ति मुनय: परमं पुमांसमादित्य-
// वर्णममलं तमस: पुरस्तात् ।
// त्वामेव सम्यगुपलभ्य जयन्ति मृत्युं,
// नान्य: शिव: शिवपदस्य मुनीन्द्र! पन्था: ॥२३॥`,

//   transliteration: `Tvām āmananti munayaḥ paramaṃ pumāṃsam
// Āditya-varṇam amalaṃ tamasaḥ purastāt।
// Tvām eva samyag upalabhya jayanti mṛtyuṃ
// Nānyaḥ śivaḥ śivapadasya munīndra! panthāḥ॥23॥`,

//   english: "The sages proclaim You as the Supreme Being, shining like the sun, spotless, beyond darkness. By truly realizing You alone, they conquer death. O Lord of sages! There is no other path to liberation.",

//   hindi: "ऋषिगण आपको परम पुरुष कहते हैं, जो सूर्य के समान तेजस्वी, निष्कलंक और अंधकार से परे हैं। केवल आपके साक्षात्कार से ही मृत्यु पर विजय मिलती है। हे मुनिन्द्र! शिवपद की प्राप्ति का कोई अन्य मार्ग नहीं है।",

//   benefits: "Destroys fear of death, grants liberation, and establishes firm faith in the Lord as the sole refuge."
// },
// {
//   id: 24,
//   sanskrit: `त्वा-मव्ययं विभुमचिन्त्यमसंख्यमाद्यं,
// ब्रह्माणमीश्वरमनन्तमनंगकेतुम् ।
// योगीश्वरं विदितयोगमनैकमेवं,
// ज्ञानस्वरूपममलं प्रवदन्ति सन्त: ॥२४॥`,

//   transliteration: `Tvām avyayaṃ vibhum acintyam asaṅkhyam ādyaṃ
// Brahmāṇam īśvaram anantam anaṅga-ketum।
// Yogīśvaraṃ vidita-yogam anaika-mekaṃ
// Jñāna-svarūpam amalaṃ pravadanti santaḥ॥24॥`,

//   english: "The sages proclaim You as eternal, all-pervading, inconceivable, infinite, and the beginningless. They call You Brahmā, Īśvara, the endless, the Lord of yogis, the one without second, the embodiment of pure knowledge.",

//   hindi: "सन्तजन आपको अविनाशी, सर्वव्यापक, अचिन्त्य, असंख्य और आदि बताते हैं। वे आपको ब्रह्मा, ईश्वर, अनंत, योगियों के ईश्वर, अद्वितीय और शुद्ध ज्ञानस्वरूप कहते हैं।",

//   benefits: "Strengthens wisdom, connects the devotee to the eternal truth, and awakens divine perception."
// },
// {
//   id: 25,
//   sanskrit: `बुद्धस्त्वमेव विबुधार्चितबुद्धिबोधात्,
// त्वं शंकरोऽसि भुवनत्रयशंकरत्वात् ।
// धातासि धीर! शिवमार्गविधेर्विधानात्,
// व्यक्तं त्वमेव भगवन् पुरुषोत्तमोऽसि ॥२५॥`,

//   transliteration: `Buddhas tvam eva vibudhārcita-buddhi-bodhāt
// Tvaṃ śaṅkaro’si bhuvana-traya-śaṅkaratvāt।
// Dhātāsi dhīra! śiva-mārga-vidher vidhānāt
// Vyaktaṃ tvam eva bhagavan puruṣottamo’si॥25॥`,

//   english: "You are Buddha, for You enlighten the intellect worshiped by the wise. You are Śaṅkara, for You bring peace to the three worlds. You are the Creator, guiding the path of liberation. O Lord, clearly You are the Supreme Purusha.",

//   hindi: "आप बुद्ध हैं क्योंकि आप विद्वानों की वंदित बुद्धि को प्रकाशित करते हैं। आप शंकर हैं क्योंकि आप तीनों लोकों को कल्याण प्रदान करते हैं। आप विधाता हैं क्योंकि आप शिवमार्ग का विधान करते हैं। हे प्रभु! आप स्पष्ट रूप से पुरुषोत्तम हैं।",

//   benefits: "Grants clarity, destroys delusion, and affirms the Lord as supreme among gods and sages."
// },
// {
//   id: 26,
//   sanskrit: `तुभ्यं नमस्त्रिभुवनार्तिहराय नाथ!
// तुभ्यं नम: क्षितितलामलभूषणाय ।
// तुभ्यं नमस्त्रिजगत: परमेश्वराय,
// तुभ्यं नमो जिन! भवोदधिशोषणाय ॥२६॥`,

//   transliteration: `Tubhyaṃ namas tribhuvanārti-harāya nātha!
// Tubhyaṃ namaḥ kṣititalāmala-bhūṣaṇāya।
// Tubhyaṃ namas trijagataḥ parameśvarāya
// Tubhyaṃ namo jina! bhavodadhi-śoṣaṇāya॥26॥`,

//   english: "Salutations to You, O Lord! Reliever of the sufferings of the three worlds, pure adornment of the earth, Supreme Lord of the universe, O Jina, who dries up the ocean of existence.",

//   hindi: "हे नाथ! आपको नमस्कार है, जो त्रिलोक की पीड़ाओं का निवारण करते हैं। आपको नमस्कार है, जो पृथ्वी के निर्मल आभूषण हैं। आपको नमस्कार है, जो त्रिजगत के परमेश्वर हैं। हे जिनेन्द्र! आपको नमस्कार है, जो भवसागर को सुखा देते हैं।",

//   benefits: "Removes suffering, destroys karmic bondage, and brings peace and liberation."
// },
// {
//   id: 27,
//   sanskrit: `को विस्मयोऽत्र यदि नाम गुणैरशेषैस्-
// त्वं संश्रितो निरवकाशतया मुनीश !
// दोषैरुपात्तविविधाश्रयजातगर्वै:,
// स्वप्नान्तरेऽपि न कदाचिदपीक्षितोऽसि ॥२७॥`,

//   transliteration: `Ko vismayo’tra yadi nāma guṇair aśeṣais
// Tvaṃ saṃśrito niravakāśatayā munīśa!
// Doṣair upātta-vividhāśraya-jāta-garvaiḥ
// Svapnāntare’pi na kadācid apīkṣito’si॥27॥`,

//   english: "What wonder is there, O Lord of sages, if You are revered with countless virtues filling every space? Those tainted with faults and pride are not fit even in dreams to behold You.",

//   hindi: "हे मुनिश्रेष्ठ! इसमें आश्चर्य ही क्या है कि आप असंख्य गुणों से युक्त होकर सभी द्वारा वंदनीय हैं। जिनके भीतर दोष और गर्व है वे तो स्वप्न में भी आपके दर्शन नहीं कर सकते।",

//   benefits: "Removes arrogance, inspires humility, and makes the soul fit to receive divine vision."
// },
// {
//   id: 28,
//   sanskrit: `उच्चैरशोकतरुसंश्रितमुनमयूख-
// माभाति रूपममलं भवतो नितान्तम् ।
// स्पष्टोल्लसत्किरणमस्ततमोवितानं,
// बिम्बं रवेरिव पयोधरपार्श्ववर्ति ॥२८॥`,

//   transliteration: `Uccair aśoka-taru-saṃśrita-munam-ayūkha-
// Mābhāti rūpam amalaṃ bhavato nitāntam।
// Spaṣṭollasat-kiraṇam asta-tamo-vitānaṃ
// Bimbaṃ raver iva payodhara-pārśva-varti॥28॥`,

//   english: "Your spotless form shines intensely, like the bright moon among Aśoka trees, scattering the veil of darkness with clear rays—just as the sun’s orb shines beside a cluster of clouds.",

//   hindi: "आपका निर्मल स्वरूप अत्यंत प्रखर रूप से शोभित है, जैसे अशोक वृक्षों में चंद्रमा। वह अपनी स्वच्छ किरणों से अंधकार को नष्ट करता है, जैसे सूर्य का बिम्ब बादलों के समीप चमकता है।",

//   benefits: "Purifies vision, removes darkness of ignorance, and fills the devotee with divine radiance."
// },
// {
//   id: 29,
//   sanskrit: `सिंहासने मणिमयूखशिखाविचित्रे,
// विभ्राजते तव वपुः कनकावदातम् ।
// बिम्बं वियद्विलसदंशुलतावितानं,
// तुंगोदयाद्रिशिरसीव सहस्ररश्मे: ॥२९॥`,

//   transliteration: `Siṃhāsane maṇi-mayūkha-śikhā-vicitre
// Vibhrājate tava vapuḥ kanakāvadātam।
// Bimbaṃ viyad-vilasad-aṃśu-latā-vitānaṃ
// Tuṅgodaya-adri-śirasīva sahasra-raśmeḥ॥29॥`,

//   english: "Seated on a throne studded with radiant gems, Your golden pure body shines brilliantly like the sun rising on the lofty peak of the eastern mountain, spreading streams of light across the sky.",

//   hindi: "मणियों की प्रभा से अलंकृत सिंहासन पर आपका स्वर्णाभ निर्मल शरीर ऐसे चमकता है, जैसे पूरब के पर्वत की चोटी पर उदित होता हुआ सूर्य अपनी किरणों की लताओं को आकाश में फैला देता है।",

//   benefits: "Grants visions of divine majesty, enhances inner dignity, and strengthens devotion."
// },
// {
//   id: 30,
//   sanskrit: `कुन्दावदातचलचामरचारुशोभं,
// विभ्राजते तव वपुः कलधौतकान्तम् ।
// उद्यच्छशांकशुचिनिर्झरवारिधार-
// मुच्चैस्तटं सुरगिरेरिव शातकौम्भम् ॥३०॥`,

//   transliteration: `Kundāvadāta-cala-cāmara-cāru-śobhaṃ
// Vibhrājate tava vapuḥ kaladhauta-kāntam।
// Udyac-chaśāṅka-śuci-nirjhara-vāri-dhāra-
// Muccaiḥ-taṭaṃ sura-girer iva śātakauṃbham॥30॥`,

//   english: "Your radiant body shines with spotless whiteness, adorned by waving white whisks. It resembles the golden peak of the celestial mountain bathed by pure streams of moonlit waterfalls.",

//   hindi: "आपका शरीर उज्ज्वल कन्द फूलों की भाँति श्वेत है, जिस पर चलायमान चामर शोभा देते हैं। यह ऐसा प्रतीत होता है मानो देवगिरि की स्वर्णमयी चोटी पर चंद्रमा की निर्मल धाराएँ गिर रही हों।",

//   benefits: "Purifies the heart, bestows serenity, and fills life with divine splendor."
// },
// {
//   id: 31,
//   sanskrit: `छत्रत्रयं तव विभाति शशांककान्तं,
// मुच्चैः स्थितं स्थगितभानुकरप्रतातम् ।
// मुक्ताफलप्रकरजालविवृद्धशोभं,
// प्रख्यापयत्त्रिजगतः परमेश्वरत्वम् ॥३१॥`,

//   transliteration: `Chatra-trayaṃ tava vibhāti śaśāṅka-kāntaṃ
// Muccaiḥ sthitaṃ sthagita-bhānu-kara-pratātam।
// Muktā-phala-prakara-jāla-vivṛddha-śobhaṃ
// Prakhyāpayat trijagataḥ parameśvaratvam॥31॥`,

//   english: "Your triple parasol shines with the brilliance of the moon, high above, outshining the sun’s rays, adorned with strings of pearls, proclaiming Your supreme lordship over the three worlds.",

//   hindi: "आपका त्रिच्छत्र चंद्रकांतिमान होकर उच्च स्थान पर शोभित हो रहा है। यह सूर्य की प्रभा को ढक देता है और मोतियों की मालाओं से सुशोभित होकर आपके त्रिभुवन-ईश्वरत्व की घोषणा करता है।",

//   benefits: "Symbol of sovereignty, bestows honor, and reminds the devotee of the Lord’s supreme rulership."
// },
// {
//   id: 32,
//   sanskrit: `गम्भीरताररवपूरितदिग्विभागस्-
// त्रैलोक्यलोकशुभसंगमभूतिदक्ष: ।
// सद्धर्मराजजयघोषणघोषक: सन्,
// खे दुन्दुभिध्र्वनति ते यशस: प्रवादी ॥३२॥`,

//   transliteration: `Gambhīra-tāra-rava-pūrita-dig-vibhāgas
// Trailokya-loka-śubha-saṅgama-bhūti-dakṣaḥ।
// Saddharma-rāja-jaya-ghoṣaṇa-ghoṣakaḥ san
// Khe dundubhi-dhvanati te yaśasaḥ pravādī॥32॥`,

//   english: "The celestial drums resound in the sky with deep tones, filling the quarters. They proclaim the victory of the true Dharma and announce Your glory, bringing welfare to the three worlds.",

//   hindi: "आकाश में गम्भीर ध्वनि के साथ दुदुंभियां बज रही हैं, जो सम्पूर्ण दिशाओं को गुंजायमान कर देती हैं। वे सद्धर्मराज की जयघोष करती हैं और आपके यश को तीनों लोकों में फैलाती हैं।",

//   benefits: "Spreads auspiciousness, invokes divine protection, and proclaims victory of Dharma."
// },
// {
//   id: 33,
//   sanskrit: `मन्दारसुन्दरनमेरुसुपारिजात-
// सन्तानकादिकुसुमोत्करवृष्टिरुद्धा ।
// गन्धोदबिन्दुशुभमन्दमरुत्प्रपाता,
// दिव्या दिव: पतति ते वचसां ततिर्वा ॥३३॥`,

//   transliteration: `Mandāra-sundara-nameru-su-pārijāta-
// Santānaka-ādi-kusumotkara-vṛṣṭi-ruddhā।
// Gandhoda-bindu-śubha-manda-marut-prapātā
// Divyā divaḥ patati te vacasāṃ tatir vā॥33॥`,

//   english: "Showers of divine flowers like Mandāra, Nameru, Pārijāta, and Santānaka rain down, carried by gentle, fragrant breezes. From heaven itself descends a celestial stream of words in Your praise.",

//   hindi: "मन्दार, नमेरु, पारिजात, संतानक आदि दिव्य पुष्पों की वर्षा स्वर्ग से होती है, जिन्हें सुगंधित मंद पवन लाता है। ऐसा लगता है मानो स्वर्ग से ही आपके गुणों की स्तुति उतर रही हो।",

//   benefits: "Brings divine blessings, fills life with fragrance of virtues, and creates an auspicious atmosphere."
// },
// {
//   id: 34,
//   sanskrit: `शुम्भत्-प्रभा-वलय-भूरि-विभा-विभोस्ते,
// लोक-त्रये-द्युतिमतां द्युति-माक्षिपन्ती ।
// प्रोद्यद्-दिवाकर-निरन्तर-भूरि-संख्या,
// दीप्त्या जयत्यपि निशामपि सोमसौम्याम् ॥३४॥`,

//   transliteration: `Śumbhat-prabhā-valaya-bhūri-vibhā-vibhōste
// Loka-traye-dyutimatāṃ dyuti-mākṣipantī।
// Prodyad-divākara-nirantara-bhūri-saṅkhyā
// Dīptyā jayatyapi niśāmapi somasaumyām॥34॥`,

//   english: "O Radiant One! The brilliance of Your aura eclipses the luster of all shining beings in the three worlds. Its unending rays surpass even the cool beauty of the moon at night.",

//   hindi: "हे प्रभो! आपकी प्रभामंडल की ज्योति त्रिलोक के सभी प्रकाशमान प्राणियों की आभा को ढक देती है। उसकी अनंत किरणें रात में भी चंद्रमा की शीतलता को मात देती हैं।",

//   benefits: "Destroys ignorance, fills the mind with divine radiance, and bestows inner clarity."
// },
// {
//   id: 35,
//   sanskrit: `स्वर्गापवर्ग-गम-मार्ग-विमार्गणेष्ट:,
// सद्धर्म-तत्त्व-कथनैक-पटुस्-त्रिलोक्या: ।
// दिव्य-ध्वनि-र्भवति ते विशदार्थ-सर्व-
// भाषास्वभाव-परिणाम-गुणै: प्रयोज्य: ॥३५॥`,

//   transliteration: `Svargāpavarga-gama-mārga-vimārgaṇeṣṭaḥ
// Saddharma-tattva-kathanai-ka-paṭus-trilokyāḥ।
// Divya-dhvaniḥ bhavati te viśadārtha-sarva-
// Bhāṣā-svabhāva-pariṇāma-guṇaiḥ prayojyaḥ॥35॥`,

//   english: "Your divine sound, O Lord, reveals the true path leading to heaven and liberation. It flows in all languages with perfect clarity, naturally understood by beings of all realms.",

//   hindi: "हे प्रभु! आपका दिव्य उपदेश स्वर्ग और मोक्ष के मार्ग का उद्घाटन करता है। वह सभी भाषाओं में स्वाभाविक रूप से स्पष्ट अर्थ प्रदान करता है, जिसे त्रिलोक के प्राणी समझ लेते हैं।",

//   benefits: "Increases understanding of dharma, grants clarity in speech, and removes confusion in spiritual path."
// },
// {
//   id: 36,
//   sanskrit: `उन्निद्र-हेम-नव-पंकज-पुंज-कान्ती,
// पर्युल्लसन्-नख-मयूख-शिखाभिरामौ।
// पादौ पदानि तव यत्र जिनेन्द्र ! धत्त:,
// पद्मानि तत्र विबुधा: परिकल्पयन्ति ॥३६॥`,

//   transliteration: `Unnidra-hema-nava-paṅkaja-puñja-kāntī
// Paryullasan-nakha-mayūkha-śikhābhirāmau।
// Pādau padāni tava yatra jinendra! dhattaḥ
// Padmāni tatra vibudhāḥ parikalpayanti॥36॥`,

//   english: "O Lord of Jinas! Wherever Your radiant feet—shining with nail rays like golden lotus clusters—step, the gods imagine blooming lotuses to be manifest there.",

//   hindi: "हे जिनेन्द्र! जहाँ-जहाँ आपके चरण, जिनकी नखकिरणें स्वर्णकमल समूह जैसी चमकती हैं, पड़ते हैं, वहाँ देवगण कमलों की कल्पना कर लेते हैं।",

//   benefits: "Purifies places of worship, removes sins of past karmas, and sanctifies the devotee’s path."
// },
// {
//   id: 37,
//   sanskrit: `इत्थं यथा तव विभूति-रभूज्जिनेन्द्र !
// धर्मोपदेशन-विधौ न तथा परस्य।
// यादृक्-प्रभा दिनकृत: प्रहतान्धकारा,
// तादृक्-कुतो ग्रहगणस्य विकासिनोऽपि ॥३७॥`,

//   transliteration: `Itthaṃ yathā tava vibhūtir abhūj-jinendra!
// Dharmopadeśana-vidhau na tathā parasya।
// Yādṛk-prabhā dinakṛtaḥ prahatāndhakārā
// Tādṛk-kuto grahagaṇasya vikāsino’pi॥37॥`,

//   english: "O Jinendra! Your greatness in teaching dharma is unmatched. Just as the sun alone dispels darkness—while even shining planets cannot—so too none equal You in spreading truth.",

//   hindi: "हे जिनेन्द्र! धर्मोपदेश में आपकी विभूति किसी अन्य की नहीं है। जैसे सूर्य अंधकार को मिटा देता है, वैसे अन्य ग्रह चाहे चमकते हों, वैसी शक्ति उनमें नहीं।",

//   benefits: "Strengthens faith in true teachers, clears ignorance, and nurtures devotion."
// },
// {
//   id: 38,
//   sanskrit: `श्च्यो-तन्-मदाविल-विलोल-कपोल-मूल,
// मत्त-भ्रमद्-भ्रमर-नाद-विवृद्ध-कोपम्।
// ऐरावताभमिभ-मुद्धतमापतन्तं
// दृष्ट्वा भयं भवति नो भवदाश्रितानाम् ॥३८॥`,

//   transliteration: `Ścyotan-madāvila-vilola-kapola-mūla
// Matta-bhramad-bhramara-nāda-vivṛddha-kopam।
// Airāvatābham ibham uddhatam āpatantaṃ
// Dṛṣṭvā bhayaṃ bhavati no bhavad-āśritānām॥38॥`,

//   english: "When a furious elephant, like Airavata, charges with anger—ears flapping, temples streaming with ichor—the devotees who take refuge in You feel no fear upon seeing it.",

//   hindi: "जब मत्त गजराज, जो ऐरावत समान है, क्रोध से गरजता हुआ आता है, तब भी जो आपके शरणागत हैं वे भयभीत नहीं होते।",

//   benefits: "Removes fear of elephants and wild beasts; protects travelers and forest dwellers."
// },
// {
//   id: 39,
//   sanskrit: `भिन्नेभ-कुम्भ-गल-दुज्ज्वल-शोणिताक्त,
// मुक्ता-फल-प्रकरभूषित-भूमि-भाग:।
// बद्ध-क्रम: क्रम-गतं हरिणाधिपोऽपि,
// नाक्रामति क्रम-युगाचल-संश्रितं ते ॥३९॥`,

//   transliteration: `Bhinnebha-kumbha-gala-dujjvala-śoṇitākta
// Muktā-phaḷa-prakara-bhūṣita-bhūmi-bhāgaḥ।
// Baddha-kramaḥ krama-gataṃ hariṇādhipo’pi
// Nākrāmati krama-yugācala-saṃśritaṃ te॥39॥`,

//   english: "Even a lion, fierce and victorious over elephants, does not attack the devotee who takes shelter at Your feet, O Lord, as though protected by an immovable mountain.",

//   hindi: "हे प्रभु! सिंह, जो गजराजों को भी जीत चुका है, वह भी आपके चरणों का आश्रय लेने वाले भक्त पर आक्रमण नहीं करता, मानो वे अचल पर्वत से सुरक्षित हों।",

//   benefits: "Removes fear of lions, wild animals, and violent enemies."
// },
// {
//   id: 40,
//   sanskrit: `कल्पान्त-काल-पवनोद्धत-वह्नि-कल्पं,
// दावानलं ज्वलित-मुज्ज्वल-मुत्स्फुलिंगम्।
// विश्वं जिघत्सुमिव सम्मुखमापतन्तं,
// त्वन्नाम-कीर्तन-जलं शमयत्यशेषम् ॥४०॥`,

//   transliteration: `Kalpānta-kāla-pavanoddhata-vahni-kalpaṃ
// Dāvānalaṃ jvalita-mujjvala-mutsphuliṅgam।
// Viśvaṃ jighatsumiva sammukham āpatantaṃ
// Tvannāma-kīrtana-jalaṃ śamayaty-aśeṣam॥40॥`,

//   english: "When a raging forest fire, fanned like the final wind of dissolution, comes threatening to consume the world, chanting Your holy name is like water that completely quenches it.",

//   hindi: "कल्पांत काल के समान प्रचंड पवन से भड़की हुई दावानल जब सब कुछ भस्म करने आती है, तब आपका नाम-स्मरण अमृतजल की तरह उसे तुरंत शांति देता है।",

//   benefits: "Removes danger from fire, accidents, and calms destructive forces."
// },
// {
//   id: 41,
//   sanskrit: `रक्तेक्षणं समद-कोकिल-कण्ठ-नीलम्,
// क्रोधोद्धतं फणिन-मुत्फण-मापतन्तम्।
// आक्रामति क्रम-युगेण निरस्त-शंकस्-
// त्वन्नाम-नागदमनी हृदि यस्य पुंस: ॥४१॥`,

//   transliteration: `Raktekṣaṇaṃ samada-kokila-kaṇṭha-nīlam
// Krodhoddhataṃ phaṇinam utphaṇam āpatantam।
// Ākrāmati krama-yugeṇa nirasta-śaṅkas-
// Tvannāma-nāgadamanī hṛdi yasya puṃsaḥ॥41॥`,

//   english: "A furious serpent, red-eyed and raising its hood, rushing to strike—cannot harm the one whose heart holds Your name, O Lord, for it acts as the supreme serpent-charm.",

//   hindi: "क्रोधोन्मत्त लाल-नेत्र वाला फणा उठाए विषधर सर्प भी आपके नाम को हृदय में धारण करने वाले भक्त का कुछ नहीं बिगाड़ सकता।",

//   benefits: "Protects against snake bites, poison, and hidden dangers."
// },
// {
//   id: 42,
//   sanskrit: `वल्गत्-तुरंग-गज-गर्जित-भीमनाद-
// माजौ बलं बलवता-मपि-भूपतीनाम्।
// उद्यद्-दिवाकर-मयूख-शिखापविद्धं
// त्वत्कीर्तनात्तमिवाशु भिदामुपैति ॥४२॥`,

//   transliteration: `Valgat-turaṅga-gaja-garjita-bhīma-nādam
// Ājau balaṃ balavatām api bhūpatīnām।
// Udyad-divākara-mayūkha-śikhāpaviddhaṃ
// Tvat-kīrtanāt tam ivāśu bhidām upaiti॥42॥`,

//   english: "The terrifying armies of mighty kings, resounding with elephants’ roars and horses’ neighs, are swiftly destroyed like darkness pierced by the sun’s rays—by the power of chanting Your name.",

//   hindi: "हाथियों की गर्जना और घोड़ों के हिनहिनाने से गूंजते हुए बलवान राजाओं के भीषण सैन्यबल भी आपके नाम-स्मरण से ऐसे नष्ट हो जाते हैं, जैसे उगते सूर्य की किरणों से अंधकार।",

//   benefits: "Grants victory in battles, protects from enemies, and removes dangers in conflicts."
// },
// {
//   id: 43,
//   sanskrit: "कुन्ताग्र-भिन्न-गज-शोणित-वारिवाह,\nवेगावतार-तरणातुर-योध-भीमे।\nयुद्धे जयं विजित-दुर्जय-जेय-पक्षास्-\nत्वत्पाद-पंकज-वनाश्रयिणो लभन्ते ॥४३॥",
//   transliteration: "Kuntāgra-bhinna-gaja-śoṇita-vārivāha,\nVegāvatāra-taraṇātura-yodha-bhīme.\nYuddhe jayaṃ vijita-durjaya-jeya-pakṣās-\nTvat-pāda-paṅkaja-vanāśrayiṇo labhante॥43॥",
//   english: "In the fierce battle where elephants bleed and warriors are terrified, those who take refuge in Your lotus feet attain certain victory, even over the invincible.",
//   hindi: "जहाँ युद्ध में हाथियों का रक्त बह रहा हो और योद्धा भयभीत हों, वहाँ आपके चरणकमल का आश्रय लेने वाले अजेयों पर भी विजय प्राप्त करते हैं।",
//   benefits: "Ensures victory in difficult battles and provides divine courage."
// },
// {
//   id: 44,
//   sanskrit: "अम्भोनिधौ क्षुभित-भीषण-नक्र-चक्र-\nपाठीन-पीठ-भय-दोल्वण-वाडवाग्नौ।\nरंगत्तरंग-शिखर-स्थित-यान-पात्रास्-\nत्रासं विहाय भवतः स्मरणाद्-व्रजन्ति ॥४४॥",
//   transliteration: "Ambhonidhau kṣubhita-bhīṣaṇa-nakra-cakra-\nPāṭhīna-pīṭha-bhaya-dolvaṇa-vāḍavāgnau.\nRaṅgattaranga-śikhara-sthita-yāna-pātrās-\nTrāsaṃ vihāya bhavataḥ smaraṇād-vrajanti॥44॥",
//   english: "In the stormy ocean, filled with dreadful crocodiles, whirlpools, and submarine fire, those aboard trembling ships become fearless by remembering You.",
//   hindi: "प्रचंड समुद्र में, जहाँ मगर, भंवर और वडवाग्नि का भय हो, वहाँ जहाज पर बैठे लोग भी आपके स्मरण से निर्भय हो जाते हैं।",
//   benefits: "Protects during sea voyages and saves from drowning or water-related fears."
// },
// {
//   id: 45,
//   sanskrit: "उद्भूत-भीषण-जलोदर-भार-भुग्ना:,\nशोच्यां दशामुपगताश्च्युत-जीविताशा:।\nत्वत्पाद-पंकज-रजो-मृत-दिग्ध-देहा:,\nमर्त्या भवन्ति मकरध्वज-तुल्यरूपा: ॥४५॥",
//   transliteration: "Udbhūta-bhīṣaṇa-jalodara-bhāra-bhugnāḥ,\nŚocyāṃ daśām-upagatāś-cyuta-jīvitāśāḥ.\nTvat-pāda-paṅkaja-rajo-mṛta-digdha-dehāḥ,\nMartyā bhavanti makaradhvaja-tulyarūpāḥ॥45॥",
//   english: "Those afflicted by deadly diseases, losing all hope of life, are restored to health and beauty like Cupid by the dust of Your lotus feet.",
//   hindi: "जो भयंकर रोगों से पीड़ित होकर जीवन की आशा खो देते हैं, वे आपके चरण-रज से निरोग और सुंदर हो जाते हैं।",
//   benefits: "Removes diseases, restores health, and grants physical beauty."
// },
// {
//   id: 46,
//   sanskrit: "आपाद-कण्ठ-मुरु-शृंखल-वेष्टितांगा:,\nगाढं बृहन्निगड-कोटिनिघृष्ट-जंघा:।\nत्वन्नाम-मन्त्र-मनिशं मनुजा: स्मरन्त:,\nसद्य: स्वयं विगत-बन्धभया भवन्ति ॥४६॥",
//   transliteration: "Āpāda-kaṇṭha-muru-śṛṅkhala-veṣṭitāṅgāḥ,\nGāḍhaṃ bṛhanni-gaḍa-koṭini-ghṛṣṭa-jaṅghāḥ.\nTvat-nāma-mantra-maniśaṃ manujāḥ smarantaḥ,\nSadyaḥ svayaṃ vigata-bandha-bhayā bhavanti॥46॥",
//   english: "Men bound from head to foot with strong chains and iron shackles are instantly freed from fear of bondage by chanting Your name.",
//   hindi: "जो लोग सिर से पाँव तक बेड़ियों और जंजीरों से जकड़े हों, वे आपका नाम स्मरण करने से तुरंत मुक्त हो जाते हैं।",
//   benefits: "Destroys imprisonment, releases from shackles, and grants freedom."
// },
// {
//   id: 47,
//   sanskrit: "मत्त-द्विपेन्द्र-मृगराज-दवानलाहि-\nसंग्राम-वारिधि-महोदर-बन्ध-नोत्थम्।\nतस्याशु नाशमुपयाति भयं भियेव,\nयस्तावकं स्तव-मिमं मतिमानधीते ॥४७॥",
//   transliteration: "Matta-dvipendra-mṛgarāja-davānālāhi-\nSaṅgrāma-vāridhi-mahodara-bandha-nottham.\nTasyāśu nāśam-upayāti bhayaṃ bhiyeva,\nYas-tāvakaṃ stava-mimaṃ matimān adhīte॥47॥",
//   english: "The wise one who recites this hymn is freed from fears of elephants, lions, fire, snakes, battles, floods, diseases, and imprisonment.",
//   hindi: "जो बुद्धिमान व्यक्ति इस स्तोत्र का पाठ करता है, वह हाथी, सिंह, आग, सर्प, युद्ध, समुद्र, रोग और बंधन जैसे भय से मुक्त हो जाता है।",
//   benefits: "Removes all fears and dangers; grants complete protection."
// },
// {
//   id: 48,
//   sanskrit: "स्तोत्र-स्रजं तव जिनेन्द्र गुणैर्निबद्धाम्,\nभक्त्या मया विविध-वर्ण-विचित्र-पुष्पाम्।\nधत्ते जनो य इह कण्ठ-गता-मजस्रं,\nतं मानतुंग-मवशा-समुपैति लक्ष्मी: ॥४८॥",
//   transliteration: "Stotra-srajaṃ tava jinendra guṇair-nibaddhām,\nBhaktyā mayā vividha-varṇa-vicitra-puṣpām.\nDhatte jano ya iha kaṇṭha-gatām-ajasraṃ,\nTaṃ Mānatunga-mavaśā-samupaiti Lakṣmīḥ॥48॥",
//   english: "This garland of verses, woven with devotion and adorned with the flowers of virtues, if worn constantly in the heart or recited, brings the blessing of Goddess Lakshmi to the devotee.",
//   hindi: "भक्ति से गुण-पुष्पों से रचित यह स्तोत्र-हार जो जन कंठ में धारण करता है या स्मरण करता है, उसके पास माँ लक्ष्मी अनायास ही आती हैं।",
//   benefits: "Brings prosperity, divine grace, and eternal fortune."
// }
// ];


export const versesData = [
  {
    id: 1,
    sanskrit: `भक्तामर प्रणतमौलि-मणि-प्रभाणा-
मुद्योतकं दलित-पाप-तमो-वितानम् ।
सम्यक् प्रणम्य जिन-पाद-युगं युगाद्या-
वालम्बनं भव-जले पततां जनानाम् ॥१॥`,
    transliteration: `Bhaktāmara praṇata-mauli-maṇi-prabhāṇā-
Udyotakaṃ dalita-pāpa-tamo-vitānam।
Samyak praṇamya jina-pāda-yugaṃ yugādyā-
Vālambanaṃ bhava-jale patatāṃ janānām॥1॥`,
    english:
      "I bow to the supreme Jina, whose radiant feet, illuminated by the jeweled crowns of devotees, dispel the darkness of sins and serve as a refuge for beings drowning in the ocean of existence.",
    hindi:
      "भक्तों के मुकुट-मणियों की प्रभा से आलोकित जिनेन्द्र के चरण पापरूपी अंधकार को दूर कर देते हैं और संसार सागर में डूबते जीवों के लिए सहारा बनते हैं।",
    benefits:
      "Destroys sins and obstacles, grants refuge, peace, and liberation."
  },
  {
    id: 2,
    sanskrit: `यः संस्तुतः सकल-वाङ्मय-तत्त्व-बोधा-
दुद्भूत-बुद्धि-पटुभिः सुरलोक-नाथैः ।
स्तोत्रैर्जगत्-त्रितय-चित्त-हरैरुदारैः
स्तोष्ये किलाहमपि तं प्रथमं जिनेन्द्रम् ॥२॥`,
    transliteration: `Yaḥ saṃstutaḥ sakala-vāṅmaya-tattva-bodhā-
Dudbhūta-buddhi-paṭubhiḥ suraloka-nāthaiḥ।
Stotrair jagat-tritaya-citta-harair udāraiḥ
Stoṣye kilāham api taṃ prathamaṃ jinendram॥2॥`,
    english:
      "The Lord who is praised by the lords of heaven—wise beings who know the essence of all scriptures and whose hymns captivate the hearts of the three worlds—Him, the first Jina, I too shall praise.",
    hindi:
      "वेदों के तत्व को जानने वाले और तीनों लोकों को मोहित करने वाले देवता जिस प्रथम जिनेन्द्र की स्तुति करते हैं, मैं भी उसी जिनेन्द्र की स्तुति करता हूँ।",
    benefits:
      "Inspires wisdom, devotion, and divine favor from the enlightened ones."
  },
  {
    id: 3,
    sanskrit: `बुद्ध्या विनाऽपि विबुधार्चित-पादपीठं
स्तोतुं समुद्यतमतिर्विगतत्रपोऽहम् ।
बालं विहाय जलसंस्थितमिन्दुबिम्बं
मन्यः क इच्छति जनः सहसा ग्रहीतुम् ॥३॥`,
    transliteration: `Buddhyā vinā’pi vibudhārcita-pāda-pīṭhaṃ
Stotuṃ samudyata-matir vigata-trapo’ham।
Bālaṃ vihāya jala-saṃsthita-mindu-bimbaṃ
Manyah ka icchati janaḥ sahasā grahītum॥3॥`,
    english:
      "Though my intellect is limited, I dare to praise those feet adored by the gods. Like a child trying to grasp the moon reflected in water, I attempt the impossible out of pure devotion.",
    hindi:
      "यद्यपि मेरी बुद्धि अल्प है, फिर भी मैं देवताओं द्वारा पूजित उन चरणों की स्तुति करने का साहस करता हूँ। जैसे कोई बालक जल में दिखते चंद्रमा को पकड़ना चाहता है, वैसे ही मैं भक्ति के कारण यह प्रयास करता हूँ।",
    benefits:
      "Cultivates humility, faith, and divine courage to worship despite limitations."
  },
  {
    id: 4,
    sanskrit: `वक्तुं गुणान् गुणसमुद्र शशाङ्ककान्तान्
कस्ते क्षमः सुरगुरुप्रतिमोऽपि बुद्ध्या ।
कल्पान्तकालपवनोद्धतनक्रचक्रं
को वा तरीतुं अलमम्बुनिधिं भुजाभ्याम् ॥४॥`,
    transliteration: `Vaktum guṇān guṇa-samudra śaśāṅka-kāntān
Kaste kṣamaḥ sura-guru-pratimo’pi buddhyā।
Kalpānta-kāla-pavanoddhata-nakra-cakraṃ
Ko vā tarītuṃ alam ambunidhiṃ bhujābhyām॥4॥`,
    english:
      "Who can describe Your ocean of virtues, shining like the moon, even if one possesses the intellect of the gods? Who can cross the stormy ocean filled with crocodiles, using mere arms alone?",
    hindi:
      "हे प्रभु! आपके चंद्रमा समान उज्ज्वल गुण-सागर का वर्णन कौन कर सकता है? देवताओं के समान बुद्धिमान भी नहीं। जैसे कोई अपने बल से मगरमच्छों से भरे महासागर को पार नहीं कर सकता।",
    benefits:
      "Destroys ego, inspires reverence for divine greatness, and deepens humility."
  },
  {
    id: 5,
    sanskrit: `सोऽहं तथापि तव भक्ति-वशान्मुनीश!
कर्तुं स्तवं विगत-शक्तिरपि प्रवृत्तः ।
प्रीत्यात्मवीर्यमविचार्य मृगी मृगेन्द्रं
नाभ्येति किं निजशिशोः परिपालनार्थम् ॥५॥`,
    transliteration: `So’haṃ tathāpi tava bhakti-vaśān munīśa!
Kartuṃ stavaṃ vigata-śaktir api pravṛttaḥ।
Prīty-ātma-vīryam avicārya mṛgī mṛgendraṃ
Nābhyeti kiṃ nija-śiśoḥ paripālanārtham॥5॥`,
    english:
      "Still, O Lord of sages, though powerless, I begin to praise You out of devotion. Does not a helpless deer approach the lion to protect her young out of love, despite fear?",
    hindi:
      "हे मुनिश्रेष्ठ! शक्ति न होने पर भी मैं भक्ति के प्रभाव से आपकी स्तुति करने लगा हूँ। जैसे मृगी अपने बच्चे की रक्षा हेतु सिंह के पास भी प्रेमवश जाती है।",
    benefits:
      "Removes fear, strengthens devotion, and instills selfless love for the Lord."
  },
  {
    id: 6,
    sanskrit: `अल्पश्रुतं श्रुतवतां परिहासधाम
त्वद्भक्तिरेव मुखरी कुरुते बलान्माम् ।
यत्कोकिलः किल मधौ मधुरं विरौति
तच्चाम्रचारु-कलिका-निकरैक-हेतुः ॥६॥`,
    transliteration: `Alpaśrutaṃ śrutavatāṃ parihāsa-dhāma
Tvad-bhaktir eva mukharī kurute balān mām।
Yat kokilaḥ kila madhau madhuraṃ virauti
Tac cāmra-cāru-kalikā-nikaraika-hetuḥ॥6॥`,
    english:
      "Though my learning is meagre and laughable to the wise, Your devotion alone compels me to sing. The cuckoo too sings sweetly in spring, inspired only by the beauty of the mango blossoms.",
    hindi:
      "मेरी विद्या विद्वानों के सामने तुच्छ है, पर आपकी भक्ति ही मुझे मुखर कर देती है। जैसे कोयल वसंत में आम के पुष्पों से प्रेरित होकर मधुर गाती है।",
    benefits:
      "Encourages the unlearned to speak with devotion; inspires confidence and divine sweetness."
  },
   {
    id: 7,
    sanskrit: `त्वत्संस्तवेन भव-सन्तति-सन्निबद्धं
पापं क्षणात्क्षयमुपैति शरीर-भाजाम् ।
आक्रान्त-लोक-मलि-नील-मशेषमाशु,
सूर्यांशु-भिन्नमिव शार्वर-मन्धकारम् ॥७॥`,
    transliteration: `Tvat-saṃstavena bhava-santati-sannibaddhaṃ
Pāpaṃ kṣaṇāt kṣayam upaiti śarīra-bhājām।
Ākrānta-loka-malīnīla-maśeṣam āśu
Sūryāṃśu-bhinnam iva śārvara-mandhakāram॥7॥`,
    english:
      "By Your praise, O Lord, the sins accumulated through countless lifetimes are instantly destroyed, just as the sun’s rays swiftly dispel the deep darkness of night that engulfs the world.",
    hindi:
      "हे प्रभु! आपकी स्तुति करने से असंख्य जन्मों का संचित पाप क्षणभर में नष्ट हो जाता है, जैसे सूर्य की किरणें सम्पूर्ण लोक में फैले अंधकार को शीघ्र दूर कर देती हैं।",
    benefits:
      "Removes accumulated karmic sins, purifies the soul, and fills life with divine radiance."
  },
  {
    id: 8,
    sanskrit: `मत्त्वेति नाथ! तव संस्तवनं मयेद-
मारभ्यते तनुधियाऽपि तव प्रभावात् ।
चेतो हरिष्यति सतां नलिनी-दलेषु,
मुक्ताफल-द्युति-मुपैति ननूद-बिन्दुः ॥८॥`,
    transliteration: `Matveti nātha! tava saṃstavanaṃ mayeda-
Mārabhyate tanu-dhiyā’pi tava prabhāvāt।
Ceto hariṣyati satāṃ nalinī-daleṣu
Muktā-phaḷa-dyutim upaiti nanūd-binduḥ॥8॥`,
    english:
      "O Lord! Thinking of Your grace, I begin this hymn even with my feeble intellect. Just as a drop of water upon a lotus leaf shines like a pearl, so too my words may gain brilliance through devotion to You.",
    hindi:
      "हे नाथ! आपके प्रसाद से प्रेरित होकर मैं अपनी दुर्बल बुद्धि से भी आपकी स्तुति आरंभ करता हूँ। जैसे जल की बूँद कमल-पत्र पर गिरकर मोती के समान दीप्त हो उठती है, वैसे ही आपकी भक्ति से मेरी वाणी भी उज्जवल हो जाएगी।",
    benefits:
      "Transforms limited abilities into divine expression, fills speech with purity and grace."
  },
  {
    id: 9,
    sanskrit: `आस्तां तव स्तवन-मस्त-समस्त-दोषं,
त्वत्संकथापि जगतां दुरितानि हन्ति ।
दूरे सहस्र-किरणः कुरुते प्रभैव,
पद्माकरेषु जलजानि विकास-भाञ्जि ॥९॥`,
    transliteration: `Āstāṃ tava stavana-masta-samasta-doṣaṃ,
Tvat-saṅkathā’pi jagatāṃ duritāni hanti।
Dūre sahasra-kiraṇaḥ kurute prabhaiva
Padmākareṣu jalajāni vikāsa-bhāñji॥9॥`,
    english:
      "Even if imperfect, Your praise destroys the world’s sins. Just as the distant sun’s light makes lotuses bloom, so too the mere mention of Your glory purifies all beings.",
    hindi:
      "आपकी स्तुति यदि सभी दोषों से रहित न भी हो, तो भी केवल आपके नाम और गुणों की कथा ही संसार के पापों का नाश कर देती है। जैसे दूर से भी सूर्य की किरणें कमलों को खिला देती हैं।",
    benefits:
      "Destroys sins even by mere remembrance; brings purity and spiritual awakening."
  },
  {
    id: 10,
    sanskrit: `नात्यद्भुतं भुवन-भूषण! भूत-नाथ!
भूतैर्गुणैर्भुवि भवन्त-मभिष्टुवन्तः।
तुल्या भवन्ति भवतो ननु तेन किं वा,
भूत्याश्रितं य इह नात्म-समं करोति ॥१०॥`,
    transliteration: `Nātyadbhutaṃ bhuvana-bhūṣaṇa! bhūta-nātha!
Bhūtair guṇair bhuvi bhavantam abhiṣṭuvantaḥ।
Tulyā bhavanti bhavato nanu tena kiṃ vā,
Bhūtyāśritaṃ ya iha nātma-samaṃ karoti॥10॥`,
    english:
      "O Ornament of the Worlds, Lord of Beings! It is no wonder that those who praise You with their virtues become great themselves. For what is strange if one who relies on true greatness becomes great too?",
    hindi:
      "हे भुवन-भूषण, हे भूतनाथ! यह कोई आश्चर्य नहीं कि जो आपके गुणों की स्तुति करते हैं, वे स्वयं महान बन जाते हैं। क्योंकि जो सच्ची महिमा का आश्रय लेता है, वह स्वयं भी महिमामय हो जाता है।",
    benefits:
      "Enhances virtues, removes inferiority, and grants spiritual greatness and confidence."
  },
  {
    id: 11,
    sanskrit: `दृष्ट्वा भवन्त-मनिमेष-विलोकनीयं,
नान्यत्र तोष-मुपयाति जनस्य चक्षुः ।
पीत्वा पयः शशिकर-द्युति-दुग्ध-सिन्धोः,
क्षारं जलं जल-निधे-रसितुं क इच्छेत् ॥११॥`,
    transliteration: `Dṛṣṭvā bhavanta-manimeṣa-vilokanīyaṃ,
Nānyatra toṣam upayāti janasya cakṣuḥ।
Pītvā payaḥ śaśikara-dyuti-dugdha-sindhoḥ,
Kṣāraṃ jalaṃ jalanidher asituṃ ka icchet॥11॥`,
    english:
      "Having seen You, whose beauty is beyond compare, the eyes find no pleasure elsewhere. Who, having drunk the nectar of moonlight, would ever desire the salt water of the sea?",
    hindi:
      "हे प्रभु! आपके अनुपम स्वरूप को देखने के बाद प्राणी की आँखें और कहीं तृप्त नहीं होतीं। जैसे जिसने चंद्रकिरणों के अमृत का पान किया हो, वह समुद्र का खारा जल नहीं पीना चाहेगा।",
    benefits:
      "Fixes the mind on the divine, removes attraction to worldly beauty, grants inner bliss."
  },
  {
    id: 12,
    sanskrit: `यैः शान्त-राग-रुचिभिः परमाणुभिस्त्वं,
निर्मापित-स्त्रिभुवनैक-ललाम-भूतः।
तावन्त एव खलु तेऽप्यणवः पृथिव्यां,
यत्ते समान-मपरं न हि रूप-मस्ति ॥१२॥`,
    transliteration: `Yaiḥ śānta-rāga-rucibhiḥ paramāṇubhis tvaṃ,
Nirmāpitas tri-bhuvanai-ka-lalāma-bhūtaḥ।
Tāvant eva khalu te’pyaṇavaḥ pṛthivyāṃ,
Yatte samānam aparaṃ na hi rūpam asti॥12॥`,
    english:
      "You are formed of pure, passion-free atoms, O Ornament of the three worlds. Though the earth holds countless atoms, none equal the beauty of Your divine form.",
    hindi:
      "हे त्रिभुवन के आभूषण! आप रागरहित, पवित्र परमाणुओं से निर्मित हैं। पृथ्वी पर अनगिनत परमाणु हैं, परंतु आपके समान सुंदर रूप कहीं नहीं।",
    benefits:
      "Instills reverence for divine perfection, purifies perception, and awakens spiritual insight."
  },
  {
    id: 13,
    sanskrit: `वक्त्रं क्व ते सुर-नरोरग-नेत्र-हारि,
निःशेष-निर्जित-जगत्-त्रितयोपमानम् ।
बिम्बं कलङ्क-मलिनं क्व निशाकरस्य,
यद्वासरे भवति पाण्डु-पलाश-कल्पम् ॥१३॥`,
    transliteration: `Vaktraṃ kva te sura-naroraga-netra-hāri,
Niḥśeṣa-nirjita-jagattritayopamānam।
Bimbaṃ kalaṅka-malinaṃ kva niśākarasya,
Yad vāsare bhavati pāṇḍu-palāśa-kalpam॥13॥`,
    english:
      "Where is Your radiant face, captivating the eyes of gods, men, and serpents—surpassing the splendor of all the three worlds—and where is the blemished, pale moon that fades like a withered leaf by day?",
    hindi:
      "देवताओं, मनुष्यों और नागों की दृष्टि को मोहित करने वाला आपका मुख, जो त्रिलोक की समस्त उपमाओं को जीतता है, कहाँ और कलंकों से युक्त दिन में फीका पड़ने वाला चंद्रमा कहाँ!",
    benefits:
      "Removes vanity of worldly beauty, inspires contemplation of divine form, and enhances inner clarity."
  },
  {
    id: 14,
    sanskrit: `सम्पूर्ण-मण्डल-शशाङ्क-कला-कलाप-
शुभ्रा गुणास्त्रिभुवनं तव लङ्घयन्ति ।
ये संश्रितास्त्रिजगदीश्वर नाथमेकं,
कस्तान्निवारयति सञ्चरतो यथेष्टम् ॥१४॥`,
    transliteration: `Sampūrṇa-maṇḍala-śaśāṅka-kalā-kalāpa-
Śubhrā guṇās tri-bhuvanaṃ tava laṅghayanti।
Ye saṃśritās tri-jagad-īśvara nātham ekaṃ,
Kas tān nivārayati saṃcarato yatheṣṭam॥14॥`,
    english:
      "Your pure and radiant virtues, like the full moon’s beams, surpass the three worlds. Those who take refuge in You, O Lord of the universe, roam freely—who can ever restrain them?",
    hindi:
      "आपके श्वेत और उज्ज्वल गुण पूर्णचंद्र की कलाओं के समान हैं जो त्रिभुवन को लांघ जाते हैं। जो आपके शरणागत होते हैं, हे जगन्नाथ! वे स्वतंत्रता से विचरण करते हैं, उन्हें कौन रोक सकता है?",
    benefits:
      "Destroys all obstacles, grants freedom, and provides protection to devotees everywhere."
  },
  {
    id: 15,
    sanskrit: `चित्रं किमत्र यदि ते त्रिदशांगनाभिः,
नीतं मनो न विकार-मार्गमगात् ।
कल्पान्त-काल-मरुता चलिताचलेन,
किं मन्दराद्रि-शिखरं चलितं कदाचित् ॥१५॥`,
    transliteration: `Citraṃ kimatra yadi te tridaśāṅganābhiḥ,
Nītaṃ mano na vikāra-mārgam agāt।
Kalpānta-kāla-marutā calitācalena,
Kiṃ mandarādri-śikharaṃ calitaṃ kadācit॥15॥`,
    english:
      "It is no wonder, O Lord, that the charms of celestial maidens fail to stir the mind devoted to You. Can the lofty peak of Mount Mandara ever be shaken by the stormy winds of cosmic dissolution?",
    hindi:
      "हे प्रभु! यह आश्चर्य नहीं कि स्वर्गांगनाओं की मोहिनी छवि भी आपके भक्त के मन को विचलित नहीं कर पाती। जैसे प्रलयकाल की आँधी भी मन्दराचल की चोटी को हिला नहीं सकती।",
    benefits:
      "Grants steadiness of mind, protects from worldly temptations, and strengthens self-control."
  },
  {
    id: 16,
    sanskrit: `निर्धूम-वर्ति-रपवर्जित-तैल-पूरः,
कृत्स्नं जगत्त्रयमिदं प्रकटीकरोषि ।
गम्यो न जातु मरुतां चलिता-चलानां,
दीपोऽपरस्त्वमसि नाथ! जगत्प्रकाशः ॥१६॥`,
    transliteration: `Nirdhūma-varti-rapavarjita-taila-pūraḥ,
Kṛtsnaṃ jagat-trayam idaṃ prakaṭīkarosi।
Gamyo na jātu marutāṃ calitācalānāṃ,
Dīpo’paras tvam asi nātha! jagat-prakāśaḥ॥16॥`,
    english:
      "Like a smokeless lamp ever full of oil, You illuminate the three worlds. Unmoved by winds, unshaken by change—O Lord, You are the unmatched light of the universe!",
    hindi:
      "आप धूमरहित और सदैव तेल से पूर्ण दीपक के समान हैं, जो त्रिलोक को प्रकाशित करता है। आप वायु और परिवर्तन से अप्रभावित रहते हैं। निश्चय ही आप जगत के अद्वितीय प्रकाश हैं।",
    benefits:
      "Removes ignorance, grants inner stability, and fills life with divine illumination."
  },
  {
    id: 17,
    sanskrit: `नास्तं कदाचिदुपयासि न राहु-गम्यः,
स्पष्टीकरोषि सहसा युगपज्जगन्ति ।
नाम्भोधरोदरनिरुद्ध-महाप्रभावः,
सूर्यातिशायि-महिमासि मुनीन्द्र-लोके ॥१७॥`,
    transliteration: `Nāstaṃ kadācid upayāsi na rāhu-gamyaḥ,
Spaṣṭīkarosi sahasā yugapaj jaganti।
Nāmbhodharodara-niruddha-mahā-prabhāvaḥ,
Sūryātiśāyi-mahimāsi munīndra-loke॥17॥`,
    english:
      "You never set, nor can Rahu ever eclipse You. Instantly You illumine all worlds. Your brilliance, never obscured by clouds, outshines even the mighty sun, O Sage among sages!",
    hindi:
      "आप कभी अस्त नहीं होते और राहु आपको ग्रहण नहीं कर सकता। आप एक साथ सब लोकों को प्रकाशित करते हैं। आपकी महिमा मेघों से ढक नहीं सकती—हे मुनिन्द्र! आप सूर्य से भी श्रेष्ठ हैं।",
    benefits:
      "Destroys darkness forever, grants clarity and spiritual vision, and brings unending enlightenment."
  },
  {
    id: 18,
    sanskrit: `नित्योदयं दलित-मोह-महान्धकारं,
गम्यं न राहु-वदनस्य न वारिदानाम् ।
विभ्राजते तव मुखाब्ज-मनल्पकान्ति,
विद्योतयज्जगदपूर्व-शशाङ्क-बिम्बम् ॥१८॥`,
    transliteration: `Nityodayaṃ dalita-moha-mahāndhakāraṃ,
Gamyaṃ na rāhu-vadanasya na vāridānām।
Vibhrājate tava mukhābjamanalpa-kānti,
Vidyotayaj jagad-apūrva-śaśāṅka-bimbam॥18॥`,
    english:
      "Your lotus face rises eternally, dispelling the great darkness of delusion. Neither Rahu nor clouds can obscure its glow. Its brilliance shines beyond even the full moon that lights the world.",
    hindi:
      "आपका कमलमुख सदा उदित रहता है, जो मोह रूपी अंधकार को नष्ट करता है। न राहु इसे ग्रहण कर सकता है, न बादल ढक सकते हैं। इसकी आभा चंद्रमा से भी अधिक है जो सम्पूर्ण जगत को आलोकित करती है।",
    benefits:
      "Destroys delusion, brings everlasting light of knowledge, and fills the heart with purity."
  },
  {
    id: 19,
    sanskrit: `किं शर्वरीषु शशि-नाहि विवस्वता वा?
युष्मन्मुखेन्दुदलितेषु तमःसु नाथ!
निष्पन्न-शालि-वन-शालिनि जीव-लोके,
कार्यं कियज्जलधरैर्जलभारनम्रैः ॥१९॥`,
    transliteration: `Kiṃ śarvarīṣu śaśināhni vivasvatā vā?
Yuṣman-mukhendu-daliteṣu tamaḥsu nātha!
Niṣpanna-śāli-vana-śālinī jīvaloke,
Kāryaṃ kiyaj jaladharaiḥ jala-bhāra-namraiḥ॥19॥`,
    english:
      "When the darkness has been dispelled by Your moonlike face, O Lord, what need remains for the sun or the moon? When the fields are ripe and golden with rice, what use are heavy-laden clouds?",
    hindi:
      "हे प्रभु! जब आपके मुखचंद्रमा ने अंधकार का नाश कर दिया, तब सूर्य या चंद्रमा की क्या आवश्यकता रह जाती है? जैसे जब धान के खेत सुनहरे पक चुके हों, तब जलभरे बादलों की कोई आवश्यकता नहीं रहती।",
    benefits:
      "Brings inner fulfillment, dispels dependency on external sources, and fills life with self-sufficient divine light."
  },
  {
    id: 20,
    sanskrit: `ज्ञानं यथा त्वयि विभाति कृतावकाशं,
नैवं तथा हरि-हरादिषु नायकेषु।
तेजः स्फुरन्मणिषु याति यथा महत्त्वं,
नैवं तु काचशकले किरणाकुलेऽपि ॥२०॥`,
    transliteration: `Jñānaṃ yathā tvayi vibhāti kṛtāvakāśaṃ,
Naivaṃ tathā hari-harādiṣu nāyakeṣu।
Tejaḥ sphuran-maṇiṣu yāti yathā mahattvaṃ,
Naivaṃ tu kāca-śakale kiraṇākule’pi॥20॥`,
    english:
      "True knowledge shines only in You, O Lord—not in Hari, Hara, or other gods. Just as brilliance belongs to a real gem and not to glass pieces that merely glitter in sunlight.",
    hindi:
      "हे प्रभु! ज्ञान केवल आप में ही पूर्ण रूप से प्रकाशित होता है, न कि हरि, हर या अन्य देवताओं में। जैसे वास्तविक तेज केवल रत्न में होता है, काँच के टुकड़ों में नहीं, चाहे वे सूर्यकिरणों में चमकते हों।",
    benefits:
      "Awakens discrimination between true and false wisdom, strengthens faith in the supreme path, and removes delusion."
  },
  {
    id: 21,
    sanskrit: `मन्ये वरं हरिहरादय एव दृष्टा,
दृष्टेषु येषु हृदयं त्वयि तोषमेति।
किं वीक्षितेन भवता भुवि येन नान्यः,
कश्चिन्मनो हरति नाथ! भवान्तरेऽपि ॥२१॥`,
    transliteration: `Manye varaṃ hari-harādaya eva dṛṣṭā,
Dṛṣṭeṣu yeṣu hṛdayaṃ tvayi toṣam eti।
Kiṃ vīkṣitena bhavatā bhuvi yena nānyaḥ,
Kaścin mano harati nātha! bhavāntare’pi॥21॥`,
    english:
      "Perhaps it is well to have seen Hari and Hara, for only then does the heart find perfect contentment in You. For once one beholds You, O Lord, nothing else can ever captivate the mind—even in future births.",
    hindi:
      "शायद हरि और हर को देखना ही अच्छा है, क्योंकि उनके दर्शन के बाद ही हृदय को आपके दर्शन में पूर्ण संतोष मिलता है। हे प्रभु! आपके दर्शन के बाद तो जन्म-जन्मान्तर में भी कोई अन्य वस्तु मन को आकृष्ट नहीं कर सकती।",
    benefits:
      "Fixes the devotee’s heart solely on the divine form, granting detachment from all else and unwavering devotion."
  },
  {
    id: 22,
    sanskrit: `स्त्रीणां शतानि शतशो जनयन्ति पुत्रान्,
नान्या सुतं त्वदुपमं जननी प्रसूता।
सर्वा दिशो दधति भानि सहस्ररश्मिं,
प्राच्येव दिग् जनयति स्फुरदंशु-जालम् ॥२२॥`,
    transliteration: `Strīṇāṃ śatāni śataśo janayanti putrān,
Nānyā sutaṃ tvadupamaṃ jananī prasūtā।
Sarvā diśo dadhati bhāni sahasra-raśmiṃ,
Prācyeva dig janayati sphurad-aṃśu-jālam॥22॥`,
    english:
      "Hundreds of women may give birth to sons, yet none has ever borne one like You. All directions hold stars with a thousand rays, but only the East brings forth the radiant sun.",
    hindi:
      "सैकड़ों स्त्रियाँ अनेक पुत्र उत्पन्न करती हैं, किन्तु आपके समान कोई पुत्र किसी ने जन्मा नहीं। सभी दिशाएँ तारों से युक्त हैं, पर केवल पूर्व दिशा ही तेजस्वी सूर्य को जन्म देती है।",
    benefits:
      "Instills awe for divine uniqueness, inspires humility, and deepens reverence for the supreme being."
  },
  {
    id: 23,
    sanskrit: `त्वामामनन्ति मुनयः परमं पुमांसम्,
आदित्यवर्णममलं तमसः परस्तात्।
त्वामेव सम्यगुपलभ्य जयन्ति मृत्युं,
नान्यः शिवः शिवपदस्य मुनीन्द्र! पन्थाः ॥२३॥`,
    transliteration: `Tvām āmananti munayaḥ paramaṃ pumāṃsam,
Āditya-varṇam amalaṃ tamasaḥ parastāt।
Tvām eva samyag upalabhya jayanti mṛtyuṃ,
Nānyaḥ śivaḥ śiva-padasya munīndra! panthāḥ॥23॥`,
    english:
      "The sages declare You the Supreme Person—radiant like the sun, spotless, beyond darkness. By realizing You alone they conquer death, for O Lord of Sages, there is no other path to liberation.",
    hindi:
      "ऋषिगण आपको परम पुरुष कहते हैं, जो सूर्य के समान तेजस्वी, निष्कलंक और अंधकार से परे हैं। केवल आपके साक्षात्कार से ही मृत्यु पर विजय मिलती है, हे मुनिन्द्र! शिवपद की प्राप्ति का कोई अन्य मार्ग नहीं है।",
    benefits:
      "Removes fear of death, grants liberation and eternal peace through direct realization of the Lord."
  },
  {
    id: 24,
    sanskrit: `त्वामव्ययं विभुमचिन्त्यमसंख्यमाद्यं,
ब्रह्माणमीश्वरमनन्तमनंगकेतुम्।
योगीश्वरं विदितयोगमनैकमेवं,
ज्ञानस्वरूपममलं प्रवदन्ति सन्तः ॥२४॥`,
    transliteration: `Tvām avyayaṃ vibhum acintyam asaṅkhyam ādyaṃ,
Brahmāṇam īśvaram anantam anaṅga-ketum।
Yogīśvaraṃ vidita-yogam anaika-mekaṃ,
Jñāna-svarūpam amalaṃ pravadanti santaḥ॥24॥`,
    english:
      "The saints proclaim You as eternal, all-pervading, inconceivable, infinite, and the first cause—Brahmā, Īśvara, the endless one, Lord of yogis, unique and one without a second, the pure embodiment of knowledge.",
    hindi:
      "सन्तजन आपको अविनाशी, सर्वव्यापक, अचिन्त्य, असंख्य और आदि बताते हैं। वे आपको ब्रह्मा, ईश्वर, अनन्त, योगियों के ईश्वर, अद्वितीय और शुद्ध ज्ञानस्वरूप कहते हैं।",
    benefits:
      "Bestows spiritual wisdom, reveals the infinite nature of divinity, and connects the devotee to eternal truth."
  },
  {
    id: 25,
    sanskrit: `बुद्धस्त्वमेव विबुधार्चितबुद्धिबोधात्,
त्वं शङ्करोऽसि भुवनत्रयशङ्करत्वात्।
धातासि धीर! शिवमार्गविधेर्विधानात्,
व्यक्तं त्वमेव भगवन् पुरुषोत्तमोऽसि॥२५॥`,
    transliteration: `Buddhas tvam eva vibudhārcita-buddhi-bodhāt,
Tvaṃ śaṅkaro’si bhuvana-traya-śaṅkaratvāt।
Dhātāsi dhīra! śiva-mārga-vidher vidhānāt,
Vyaktaṃ tvam eva bhagavan puruṣottamo’si॥25॥`,
    english:
      "You are Buddha, for You awaken the intellect worshipped by the wise. You are Shankara, the benefactor of the three worlds. O steadfast Lord! You are the Creator, the establisher of the path of liberation. Clearly, O Blessed One, You are the Supreme Purusha.",
    hindi:
      "आप बुद्ध हैं क्योंकि आप बुद्धिमानों की वंदित बुद्धि को प्रकाशित करते हैं। आप शंकर हैं क्योंकि आप त्रिभुवन के कल्याणकारी हैं। हे धीर प्रभु! आप विधाता हैं जो शिवमार्ग का विधान करते हैं। निःसंदेह, हे भगवान! आप ही पुरुषोत्तम हैं।",
    benefits:
      "Grants supreme wisdom, strengthens devotion, and reveals the Lord as the ultimate source of enlightenment."
  },
  {
    id: 26,
    sanskrit: `तुभ्यं नमस्त्रिभुवनार्तिहराय नाथ!
तुभ्यं नमः क्षितितलामलभूषणाय।
तुभ्यं नमस्त्रिजगतः परमेश्वराय,
तुभ्यं नमो जिन! भवोदधिशोषणाय॥२६॥`,
    transliteration: `Tubhyaṃ namas tribhuvanārti-harāya nātha!
Tubhyaṃ namaḥ kṣititalāmala-bhūṣaṇāya।
Tubhyaṃ namas trijagataḥ parameśvarāya,
Tubhyaṃ namo jina! bhavodadhi-śoṣaṇāya॥26॥`,
    english:
      "Salutations to You, O Lord! Reliever of the sufferings of the three worlds, the pure ornament of the earth, the Supreme Lord of the universe, O Jina, who dries up the ocean of worldly existence.",
    hindi:
      "हे नाथ! आपको नमस्कार है, जो त्रिभुवन की पीड़ाओं का निवारण करते हैं। आपको नमस्कार है, जो पृथ्वी के निर्मल भूषण हैं। आपको नमस्कार है, जो त्रिजगत के परमेश्वर हैं। हे जिनेन्द्र! आपको नमस्कार है, जो भवसागर को सुखा देते हैं।",
    benefits:
      "Removes sorrows and karmic bondage, grants peace, and helps transcend the ocean of birth and death."
  },
  {
    id: 27,
    sanskrit: `को विस्मयोऽत्र यदि नामगुणैरशेषैः,
त्वं संश्रितो निरवकाशतया मुनीश।
दोषैरुपात्तविविधाश्रयजातगर्वैः,
स्वप्नान्तरेऽपि न कदाचिदपीक्षितोऽसि॥२७॥`,
    transliteration: `Ko vismayo’tra yadi nāma guṇair aśeṣaiḥ,
Tvaṃ saṃśrito niravakāśatayā munīśa।
Doṣair upātta-vividhāśraya-jāta-garvaiḥ,
Svapnāntare’pi na kadācid apīkṣito’si॥27॥`,
    english:
      "What wonder is there, O Lord of Sages, if You are revered by all because of Your countless virtues filling all space? Those possessed by faults and pride are not even fit to behold You in their dreams.",
    hindi:
      "हे मुनिश्रेष्ठ! इसमें क्या आश्चर्य है कि आप असंख्य गुणों से युक्त होकर सबके द्वारा पूजनीय हैं। जिनमें दोष और गर्व है, वे तो स्वप्न में भी आपके दर्शन नहीं कर सकते।",
    benefits:
      "Destroys ego and pride, encourages humility, and makes the heart pure enough to perceive divinity."
  },
  {
    id: 28,
    sanskrit: `उच्चैरशोकतरुसंश्रितमुनमयूख-
माभाति रूपममलं भवतो नितान्तम्।
स्पष्टोल्लसत्किरणमस्ततमोवितानं,
बिम्बं रवेः इव पयोधरपार्श्ववर्ति॥२८॥`,
    transliteration: `Uccair aśoka-taru-saṃśrita-munam-ayūkha-
Mābhāti rūpam amalaṃ bhavato nitāntam।
Spaṣṭollasat-kiraṇam asta-tamo-vitānaṃ,
Bimbaṃ raveḥ iva payodhara-pārśva-varti॥28॥`,
    english:
      "Your spotless form shines like the rising sun beside the clouds, radiant and pure, scattering the darkness of ignorance. It glows serenely, like moonlight among Ashoka trees.",
    hindi:
      "आपका निर्मल स्वरूप अशोक वृक्षों में चंद्रमा की भाँति शोभित है। यह अपनी स्वच्छ किरणों से अंधकार का नाश करता है, जैसे सूर्य का बिंब बादलों के समीप चमकता है।",
    benefits:
      "Removes ignorance, grants inner light, and fills the devotee’s mind with serene brilliance."
  },
  {
    id: 29,
    sanskrit: `सिंहासने मणिमयूखशिखाविचित्रे,
विभ्राजते तव वपुः कनकावदातम्।
बिम्बं वियद्विलसदंशुलतावितानं,
तुंगोदयाद्रिशिरसीव सहस्ररश्मेः॥२९॥`,
    transliteration: `Siṃhāsane maṇi-mayūkha-śikhā-vicitre,
Vibhrājate tava vapuḥ kanakāvadātam।
Bimbaṃ viyad-vilasad-aṃśu-latā-vitānaṃ,
Tuṅgodaya-adri-śirasīva sahasra-raśmeḥ॥29॥`,
    english:
      "Seated on a throne adorned with gems whose rays sparkle in every direction, Your golden-hued body shines like the rising sun on the summit of the eastern mountain, spreading its countless beams through the sky.",
    hindi:
      "मणियों की प्रभा से अलंकृत सिंहासन पर आपका स्वर्णाभ निर्मल शरीर ऐसे चमकता है, जैसे पूरब के पर्वत की चोटी पर उदित होता सूर्य अपनी किरणों की लताओं को फैलाता है।",
    benefits:
      "Inspires awe and majesty, fills the heart with divine splendor, and grants the vision of supreme glory."
  },
  {
    id: 30,
    sanskrit: `कुन्दावदातचलचामरचारुशोभं,
विभ्राजते तव वपुः कलधौतकान्तम्।
उद्यच्छशांकशुचिनिर्झरवारिधार-
मुच्चैस्तटं सुरगिरेरिव शातकौम्भम्॥३०॥`,
    transliteration: `Kundāvadāta-cala-cāmara-cāru-śobhaṃ,
Vibhrājate tava vapuḥ kaladhauta-kāntam।
Udyac-chaśāṅka-śuci-nirjhara-vāri-dhāra-
Muccaiḥ-taṭaṃ sura-girer iva śātakauṃbham॥30॥`,
    english:
      "Your radiant body, pure as jasmine and adorned with waving white whisks, gleams like the golden summit of the celestial mountain bathed by streams of moonlit waterfalls.",
    hindi:
      "आपका उज्ज्वल शरीर कन्द पुष्प के समान श्वेत है, जिस पर लहराते चामर शोभा देते हैं। यह ऐसा प्रतीत होता है मानो देवगिरि की स्वर्ण चोटी पर चंद्रकिरणों की निर्मल धाराएँ गिर रही हों।",
    benefits:
      "Purifies the heart, brings serenity, and fills life with divine splendor and peace."
  },
{
    id: 31,
    sanskrit: `छत्रत्रयं तव विभाति शशाङ्ककान्तं,
मुच्चैः स्थितं स्थगितभानुकरप्रभावम्।
मुक्ताफलप्रकरजालविवृद्धशोभं,
प्रख्यापयत्त्रिजगतः परमेश्वरत्वम्॥३१॥`,
    transliteration: `Chatra-trayaṃ tava vibhāti śaśāṅka-kāntaṃ,
Muccaiḥ sthitaṃ sthagita-bhānu-kara-prabhāvam।
Muktā-phala-prakara-jāla-vivṛddha-śobhaṃ,
Prakhyāpayat trijagataḥ parameśvaratvam॥31॥`,
    english:
      "Your triple parasol, shining with moon-like brilliance and adorned with pearl clusters, rises high, obscuring the radiance of the sun itself — proclaiming Your supreme sovereignty over the three worlds.",
    hindi:
      "आपका त्रिच्छत्र चंद्रकांतिमान होकर ऊँचाई पर शोभित है। यह सूर्य की प्रभा को ढक देता है और मोतियों की मालाओं से अलंकृत होकर आपके त्रिभुवन-ईश्वरत्व की घोषणा करता है।",
    benefits:
      "Symbol of divine authority and purity; grants honor, respect, and spiritual sovereignty."
  },
  {
    id: 32,
    sanskrit: `गम्भीरताररवपूरितदिग्विभागस्-
त्रैलोक्यलोकशुभसंगमभूतिदक्षः।
सद्धर्मराजजयघोषणघोषकः सन्,
खे दुन्दुभिर्ध्वनति ते यशसः प्रवादी॥३२॥`,
    transliteration: `Gambhīra-tāra-rava-pūrita-dig-vibhāgaḥ,
Trailokya-loka-śubha-saṅgama-bhūti-dakṣaḥ।
Saddharma-rāja-jaya-ghoṣaṇa-ghoṣakaḥ san,
Khe dundubhir dhvanati te yaśasaḥ pravādī॥32॥`,
    english:
      "The celestial drums echo through the sky with deep, resonant tones, spreading auspiciousness across the three worlds, proclaiming the victory of the King of True Dharma — Your glory resounding everywhere.",
    hindi:
      "आकाश में गम्भीर नाद से दुदुंभियां बज रही हैं जो सम्पूर्ण दिशाओं में शुभता फैलाती हैं। वे सद्धर्मराज की जयघोष करती हुई आपके यश का उद्घोष करती हैं।",
    benefits:
      "Brings victory of righteousness, divine recognition, and widespread fame through devotion."
  },
  {
    id: 33,
    sanskrit: `मन्दारसुन्दरनमेरुसुपारिजात-
सन्तानकादिकुसुमोत्करवृष्टिरुद्धा।
गन्धोदबिन्दुशुभमन्दमरुत्प्रपाता,
दिव्या दिवः पतति ते वचसां ततिर्वा॥३३॥`,
    transliteration: `Mandāra-sundara-nameru-su-pārijāta-
Santānaka-ādi-kusumotkara-vṛṣṭi-ruddhā।
Gandhoda-bindu-śubha-manda-marut-prapātā,
Divyā divaḥ patati te vacasāṃ tatir vā॥33॥`,
    english:
      "Showers of divine flowers — Mandāra, Nameru, Pārijāta, and Santānaka — fall from the heavens, borne by gentle, fragrant breezes. It seems as though celestial words of praise themselves are descending from the sky.",
    hindi:
      "मन्दार, नमेरु, पारिजात, संतानक आदि दिव्य पुष्पों की वर्षा स्वर्ग से होती है, जिन्हें सुगंधित मंद पवनें लाती हैं। ऐसा प्रतीत होता है जैसे स्वयं स्वर्ग से आपकी स्तुति बरस रही हो।",
    benefits:
      "Invokes divine blessings, fills surroundings with auspicious energy, and pleases celestial beings."
  },
  {
    id: 34,
    sanskrit: `शुम्भत्प्रभावलयभूरिविभाविभोस्ते,
लोकत्रये द्युतिमतां द्युतिमाक्षिपन्ती।
प्रोद्यद्दिवाकरनिरन्तरभूरिसंख्या,
दीप्त्या जयत्यपि निशामपि सोमसौम्याम्॥३४॥`,
    transliteration: `Śumbhat-prabhā-valaya-bhūri-vibhā-vibhoste,
Loka-traye dyutimatāṃ dyuti-mākṣipantī।
Prodyad-divākara-nirantara-bhūri-saṅkhyā,
Dīptyā jayaty api niśām api soma-saumyām॥34॥`,
    english:
      "O Radiant One! The brilliance of Your aura eclipses the luster of all shining beings across the three worlds. Its endless rays surpass even the cool serenity of the moon and the blazing light of the sun.",
    hindi:
      "हे प्रभो! आपकी प्रभा त्रिलोक के सभी तेजस्वी प्राणियों की आभा को ढक देती है। इसकी अनंत किरणें दिन के सूर्य और रात के चंद्रमा दोनों की ज्योति को मात देती हैं।",
    benefits:
      "Destroys inner darkness, fills one’s life with divine brilliance, and grants spiritual radiance."
  },
  {
    id: 35,
    sanskrit: `स्वर्गापवर्गगममार्गविमार्गणेष्टः,
सद्धर्मतत्त्वकथनैकपटुस्त्रिलोक्याः।
दिव्यध्वनिर्भवति ते विशदार्थसर्व-
भाषास्वभावपरिणामगुणैः प्रयोज्यः॥३५॥`,
    transliteration: `Svargāpavarga-gama-mārga-vimārgaṇeṣṭaḥ,
Saddharma-tattva-kathanai-ka-paṭus-trilokyāḥ।
Divya-dhvaniḥ bhavati te viśadārtha-sarva-
Bhāṣā-svabhāva-pariṇāma-guṇaiḥ prayojyaḥ॥35॥`,
    english:
      "Your divine sound reveals the true path leading to heaven and liberation. It manifests in every language with perfect clarity, naturally understood by beings of all realms.",
    hindi:
      "हे प्रभु! आपका दिव्य उपदेश स्वर्ग और मोक्ष के मार्ग का उद्घाटन करता है। वह सभी भाषाओं में स्पष्ट अर्थ के साथ प्रकट होता है, जिसे त्रिलोक के सभी प्राणी समझ लेते हैं।",
    benefits:
      "Grants clarity of understanding, reveals true Dharma, and removes spiritual confusion."
  },
  {
    id: 36,
    sanskrit: `उन्निद्रहेमनवपङ्कजपुञ्जकान्ति,
पर्युल्लसन्नखमयूखशिखाभिरामौ।
पादौ पदानि तव यत्र जिनेन्द्र धत्तः,
पद्मानि तत्र विबुधाः परिकल्पयन्ति॥३६॥`,
    transliteration: `Unnidra-hema-nava-paṅkaja-puñja-kānti,
Paryullasan-nakha-mayūkha-śikhābhirāmau।
Pādau padāni tava yatra jinendra dhattaḥ,
Padmāni tatra vibudhāḥ parikalpayanti॥36॥`,
    english:
      "O Lord of Jinas! Wherever Your radiant feet, shining with golden-lotus beauty and the glow of Your nails’ rays, touch the ground — the gods imagine lotuses blooming there.",
    hindi:
      "हे जिनेन्द्र! जहाँ-जहाँ आपके स्वर्णकमल सदृश चरण पड़ते हैं, जिनकी नखकिरणें सुंदर ज्योति से दमकती हैं, वहाँ देवगण कमलों की कल्पना कर लेते हैं।",
    benefits:
      "Purifies the devotee’s path, sanctifies the earth, and removes sins through reverence for the Lord’s feet."
  },
{
    id: 37,
    sanskrit: `इत्थं यथा तव विभूति-रभूज्जिनेन्द्र !
धर्मोपदेशन-विधौ न तथा परस्य।
यादृक्प्रभा दिनकृतः प्रहतान्धकारा,
तादृक् कुतो ग्रहगणस्य विकासिनोऽपि॥३७॥`,
    transliteration: `Itthaṃ yathā tava vibhūtir abhūj-jinendra!
Dharmopadeśana-vidhau na tathā parasya।
Yādṛk-prabhā dinakṛtaḥ prahatāndhakārā,
Tādṛk kuto grahagaṇasya vikāsino'pi॥37॥`,
    english:
      "O Jinendra! Your glory in teaching Dharma is unmatched. Just as only the sun dispels the darkness, not the shining planets, so none among gods or beings equal You in spreading enlightenment.",
    hindi:
      "हे जिनेन्द्र! धर्मोपदेश में आपकी विभूति किसी अन्य की नहीं है। जैसे सूर्य ही अंधकार को नष्ट करता है, वैसे ही कोई ग्रह, चाहे कितना भी चमकदार क्यों न हो, वैसा नहीं कर सकता।",
    benefits:
      "Grants spiritual clarity, strengthens devotion to the true teacher, and removes ignorance."
  },
  {
    id: 38,
    sanskrit: `श्च्योतन्मदाविलविलोलकपोलमूल-
मत्तभ्रमद्भ्रमरणादविवृद्धकोपम्।
ऐरावताभमिभमुद्धतमापतन्तं
दृष्ट्वा भयं भवति नो भवदाश्रितानाम्॥३८॥`,
    transliteration: `Ścyotan-madāvila-vilola-kapola-mūla-
Matta-bhramad-bhramara-nāda-vivṛddha-kopam।
Airāvatābham ibham uddhatam āpatantaṃ
Dṛṣṭvā bhayaṃ bhavati no bhavad-āśritānām॥38॥`,
    english:
      "When a mighty elephant, maddened and roaring like Airāvata, charges in fury with temples streaming ichor, the devotees sheltered in You feel no fear at all upon seeing it.",
    hindi:
      "जब ऐरावत के समान विशाल मत्त गजराज क्रोध से गर्जता हुआ आता है, तब भी आपके शरणागत भक्तों को तनिक भी भय नहीं होता।",
    benefits:
      "Destroys all fears, protects devotees from wild animals, and grants inner courage."
  },
  {
    id: 39,
    sanskrit: `भिन्नेभकुम्भगलदुज्ज्वलशोणिताक्त,
मुक्ताफलप्रकरभूषितभूमिभागः।
बद्धक्रमः क्रमगतं हरिणाधिपोऽपि,
नाक्रामति क्रमयुगाचलसंश्रितं ते॥३९॥`,
    transliteration: `Bhinnebha-kumbha-gala-dujjvala-śoṇitākta,
Muktā-phala-prakara-bhūṣita-bhūmi-bhāgaḥ।
Baddha-kramaḥ krama-gataṃ hariṇādhipo'pi,
Nākrāmati krama-yugācala-saṃśritaṃ te॥39॥`,
    english:
      "Even a lion, fierce and victorious over elephants, does not approach the devotee sheltered at Your steadfast feet, as though they were resting upon an immovable mountain.",
    hindi:
      "हे प्रभु! सिंह, जिसने गजराजों को भी परास्त किया हो, वह भी आपके चरणों में शरण लेने वाले भक्त पर आक्रमण नहीं करता, जैसे वे अचल पर्वत पर स्थित हों।",
    benefits:
      "Brings fearlessness, divine protection, and safety from harm or hostility."
  },
  {
    id: 40,
    sanskrit: `कल्पान्तकालपवनोद्धतवह्निकल्पं,
दावानलं ज्वलितमुज्ज्वलमुत्स्फुलिङ्गम्।
विश्वं जिघत्सुमिव सम्मुखमापतन्तं,
त्वन्नामकीर्तनजलं शमयत्यशेषम्॥४०॥`,
    transliteration: `Kalpānta-kāla-pavanoddhata-vahni-kalpaṃ,
Dāvānalaṃ jvalita-mujjvala-mutsphuliṅgam।
Viśvaṃ jighatsumiva sammukham āpatantaṃ,
Tvannāma-kīrtana-jalaṃ śamayaty-aśeṣam॥40॥`,
    english:
      "When the blazing forest fire, like the final conflagration at the world’s end, rushes forth to consume all, the cool water of Your name’s remembrance extinguishes it completely.",
    hindi:
      "जब कल्पांतकाल जैसी प्रचंड दावानल सब कुछ भस्म करने आती है, तब आपका नामस्मरण अमृत के समान उसे शांत कर देता है।",
    benefits:
      "Removes danger from fire and destruction; brings peace and divine cooling grace."
  },
  {
    id: 41,
    sanskrit: `रक्तेक्षणं समदकोकिलकण्ठनीलं,
क्रोधोद्धतं फणिनमुत्फणमापतन्तम्।
आक्रामति क्रमयुगेण निरस्तशङ्कस्-
त्वन्नामनागदमनी हृदि यस्य पुंसः॥४१॥`,
    transliteration: `Rakt-ekṣaṇaṃ samada-kokila-kaṇṭha-nīlaṃ,
Krodhoddhataṃ phaṇinam utphaṇam āpatantam।
Ākrāmati krama-yugeṇa nirasta-śaṅkas-
Tvannāma-nāgadamanī hṛdi yasya puṃsaḥ॥41॥`,
    english:
      "A fierce serpent, red-eyed and raising its hood in anger, cannot harm the one whose heart holds Your sacred name — for it acts as the supreme charm against venom and fear.",
    hindi:
      "क्रोध से फणा उठाए हुए विषधर सर्प भी उस व्यक्ति को हानि नहीं पहुँचा सकते जिसके हृदय में आपका नाम बसता है, क्योंकि वह स्वयं नागदमनी के समान रक्षक बन जाता है।",
    benefits:
      "Protects from snake bites, poisons, and hidden dangers; grants calmness under threat."
  },
  {
    id: 42,
    sanskrit: `वल्गत्तुरङ्गगजगर्जितभीमनाद-
माजौ बलं बलवतात्पि भूपतीनाम्।
उद्यद्दिवाकरमयूखशिखापविद्धं,
त्वत्कीर्तनात्तमिवाशु भिदामुपैति॥४२॥`,
    transliteration: `Valgat-turaṅga-gaja-garjita-bhīma-nādam,
Ājau balaṃ balavatām api bhūpatīnām।
Udyad-divākara-mayūkha-śikhā-paviddhaṃ,
Tvat-kīrtanāt tam ivāśu bhidām upaiti॥42॥`,
    english:
      "The terrifying armies of mighty kings, resounding with roars of elephants and neighs of horses, are swiftly destroyed like darkness pierced by the rising sun — through the power of Your praise.",
    hindi:
      "हाथियों की गर्जना और घोड़ों की हिनहिनाहट से गूँजते हुए बलवान राजाओं के सेनाबल भी आपके नामस्मरण से उसी प्रकार नष्ट हो जाते हैं जैसे उगते सूर्य की किरणों से अंधकार।",
    benefits:
      "Grants victory in battles and struggles; removes enmity, hostility, and fear of opposition."
  },
{
    id: 43,
    sanskrit: `कुन्ताग्रभिन्नगजशोणितवारिवाह,
वेगावतारतरनातुरयोधभीमे।
युद्धे जयं विजितदुर्जयजेयपक्षा-
स्त्वत्पादपङ्कजवनाश्रयिणो लभन्ते॥४३॥`,
    transliteration: `Kuntāgra-bhinna-gaja-śoṇita-vārivāha,
Vegāvatāra-taraṇātura-yodha-bhīme।
Yuddhe jayaṃ vijita-durjaya-jeya-pakṣās-
Tvat-pāda-paṅkaja-vanāśrayiṇo labhante॥43॥`,
    english:
      "In the fierce battlefield, where elephants bleed and warriors tremble, those who take refuge in Your lotus feet attain victory even over the invincible.",
    hindi:
      "जहाँ युद्धभूमि में हाथियों का रक्त बह रहा हो और योद्धा भयभीत हों, वहाँ आपके चरणकमल का आश्रय लेने वाले अजेयों पर भी विजय प्राप्त करते हैं।",
    benefits:
      "Grants victory over powerful enemies and removes fear in dangerous or challenging situations."
  },
  {
    id: 44,
    sanskrit: `अम्भोनिधौ क्षुभितभीषणनक्रचक्रे,
पाठीनपीठभयदोल्वणवाडवाग्नौ।
रङ्गत्तरङ्गशिखरस्थितयानपात्रास्-
त्रासं विहाय भवतः स्मरणाद्व्रजन्ति॥४४॥`,
    transliteration: `Ambhonidhau kṣubhita-bhīṣaṇa-nakra-cakre,
Pāṭhīna-pīṭha-bhaya-dolvaṇa-vāḍavāgnau।
Raṅgattaranga-śikhara-sthita-yāna-pātrās-
Trāsaṃ vihāya bhavataḥ smaraṇād-vrajanti॥44॥`,
    english:
      "In the stormy ocean, filled with dreadful crocodiles, whirlpools, and submarine fire, those aboard trembling ships become fearless by remembering You.",
    hindi:
      "प्रचंड समुद्र में, जहाँ मगर, भंवर और वडवाग्नि का भय हो, वहाँ जहाज पर बैठे लोग भी आपके स्मरण से निर्भय हो जाते हैं।",
    benefits:
      "Protects during sea travel, removes fear of drowning, and ensures safety amid turmoil."
  },
  {
    id: 45,
    sanskrit: `उद्भूतभीषणजलोदरभरभुग्नाः,
शोच्यां दशामुपगताश्च्युतजीविताशाः।
त्वत्पादपङ्कजरजोऽमृतदिग्धदेहाः,
मर्त्या भवन्ति मकरध्वजतुल्यरूपाः॥४५॥`,
    transliteration: `Udbhūta-bhīṣaṇa-jalodara-bhara-bhugnāḥ,
Śocyāṃ daśām-upagatāś-cyuta-jīvitāśāḥ।
Tvat-pāda-paṅkaja-rajo’mṛta-digdha-dehāḥ,
Martyā bhavanti makaradhvaja-tulya-rūpāḥ॥45॥`,
    english:
      "Those stricken with terrible diseases, having lost all hope of life, are healed and regain beauty like the god of love, by the dust of Your lotus feet.",
    hindi:
      "जो लोग भयंकर रोगों से पीड़ित होकर जीवन की आशा खो चुके हों, वे आपके चरण-रज से अमृत-स्पर्श पाकर फिर से स्वस्थ और सुंदर हो जाते हैं।",
    benefits:
      "Cures diseases, restores vitality and beauty, and blesses with renewed health."
  },
  {
    id: 46,
    sanskrit: `आपादकण्ठमुरुशृंखलवेष्टिताङ्गाः,
गाढं बृहन्निगडकोटिनिघृष्टजङ्घाः।
त्वन्नाममन्त्रमनिशं मनुजाः स्मरन्तः,
सद्यः स्वयं विगतबन्धभया भवन्ति॥४६॥`,
    transliteration: `Āpāda-kaṇṭha-muru-śṛṅkhala-veṣṭitāṅgāḥ,
Gāḍhaṃ bṛhannigaḍa-koṭini-ghṛṣṭa-jaṅghāḥ।
Tvat-nāma-mantra-maniśaṃ manujāḥ smarantaḥ,
Sadyaḥ svayaṃ vigata-bandha-bhayā bhavanti॥46॥`,
    english:
      "Men bound from head to foot in heavy chains and iron fetters are instantly freed from fear and bondage when they constantly remember Your holy name.",
    hindi:
      "जो व्यक्ति सिर से पाँव तक भारी जंजीरों और बेड़ियों से जकड़े हों, वे आपके नाम का स्मरण करने से तुरंत भय और बंधन से मुक्त हो जाते हैं।",
    benefits:
      "Removes imprisonment, mental or physical restrictions, and grants liberation from all forms of bondage."
  },
  {
    id: 47,
    sanskrit: `मत्तद्विपेन्द्रमृगराजदवानलाहि-
संग्रामवारिधिमहोदरबन्धनोत्थम्।
तस्याशु नाशमुपयाति भयं भियेव,
यस्तावकं स्तवमिमं मतिमानधीते॥४७॥`,
    transliteration: `Matta-dvipendra-mṛgarāja-davānālāhi-
Saṅgrāma-vāridhi-mahodara-bandha-nottham।
Tasyāśu nāśam-upayāti bhayaṃ bhiyeva,
Yas-tāvakaṃ stavam-imaṃ matimān adhīte॥47॥`,
    english:
      "The wise one who recites this hymn is quickly freed from all fears — of elephants, lions, fire, serpents, battles, floods, or captivity.",
    hindi:
      "जो बुद्धिमान व्यक्ति इस स्तोत्र का पाठ करता है, वह हाथी, सिंह, आग, सर्प, युद्ध, समुद्र या बंधन जैसे सभी भय से शीघ्र ही मुक्त हो जाता है।",
    benefits:
      "Destroys every kind of fear, grants divine protection, and ensures safety in all conditions."
  },
  {
    id: 48,
    sanskrit: `स्तोत्रस्रजं तव जिनेन्द्र गुणैर्निबद्धां,
भक्त्या मया विविधवर्णविचित्रपुष्पाम्।
धत्ते जनो य इह कण्ठगतामजस्रं,
तं मानतुंगमवशा समुपैति लक्ष्मीः॥४८॥`,
    transliteration: `Stotra-srajaṃ tava jinendra guṇair-nibaddhām,
Bhaktyā mayā vividha-varṇa-vicitra-puṣpām।
Dhatte jano ya iha kaṇṭha-gatām-ajasraṃ,
Taṃ Mānatunga-mavaśā samupaiti Lakṣmīḥ॥48॥`,
    english:
      "This garland of verses, woven with devotion and adorned with the flowers of virtues, if worn constantly or recited sincerely, brings the blessing of Goddess Lakshmi herself.",
    hindi:
      "भक्ति से गुण-पुष्पों से रचित यह स्तोत्रहार जो व्यक्ति नित्य स्मरण करता है या कंठ में धारण करता है, उसके पास माता लक्ष्मी स्वयं अनायास चली आती हैं।",
    benefits:
      "Brings prosperity, divine grace, and unbroken spiritual and material fortune."
  }
];